"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFilterEnum = exports.CustomColumnEnum = exports.ESORT_TYPE = exports.ESettlementState = void 0;
var ESettlementState;
(function (ESettlementState) {
    ESettlementState["SETTLE_WAIT"] = "unsettled";
    ESettlementState["SETTLE_PART"] = "partial_settlement";
    ESettlementState["SETTLE_COMPLETE"] = "already_settled";
})(ESettlementState || (exports.ESettlementState = ESettlementState = {}));
var ESORT_TYPE;
(function (ESORT_TYPE) {
    ESORT_TYPE["ascend"] = "ASC";
    ESORT_TYPE["descend"] = "DESC";
})(ESORT_TYPE || (exports.ESORT_TYPE = ESORT_TYPE = {}));
// 列定制枚举
var CustomColumnEnum;
(function (CustomColumnEnum) {
    /** 设备管理-POS机 */
    CustomColumnEnum["EQUIPMENT_POS"] = "EQUIPMENT_POS";
    /** 设备管理-移动设备 */
    CustomColumnEnum["EQUIPMENT_MOBILE_DEVICE"] = "EQUIPMENT_MOBILE_DEVICE";
    /** 云音响管理 */
    CustomColumnEnum["CLOUD_SPEAKER_MANAGEMENT"] = "CLOUD_SPEAKER_MANAGEMENT";
    /** 语音播报设置 */
    CustomColumnEnum["CLOUD_SPEAKER_RULE_MANAGEMENT"] = "CLOUD_SPEAKER_RULE_MANAGEMENT";
    /** 门店播放规则详情 */
    CustomColumnEnum["CLOUD_SPEAKER_RULE_STORE_DETAIL"] = "CLOUD_SPEAKER_RULE_STORE_DETAIL";
    /** 门店设备分组详情 */
    CustomColumnEnum["CLOUD_SPEAKER_GROUP_STORE_DETAIL"] = "CLOUD_SPEAKER_GROUP_STORE_DETAIL";
    /** 云音响设备分组管理 */
    CustomColumnEnum["CLOUD_SPEAKER_GROUP"] = "CLOUD_SPEAKER_GROUP";
    /** 裱花间-裱花间设置 */
    CustomColumnEnum["CAKE_DECORATOR_SETTING"] = "CAKE_DECORATOR_SETTING";
    /** 裱花间-门店裱花设置 */
    CustomColumnEnum["CAKE_DECORATOR_LOCATION_SETTING"] = "CAKE_DECORATOR_LOCATION_SETTING";
    /** 台位管理-台位设置 */
    CustomColumnEnum["LOCATION_TABLE"] = "LOCATION_TABLE";
    /** 台位管理-台位类型 */
    CustomColumnEnum["LOCATION_TABLE_TYPE"] = "LOCATION_TABLE_TYPE";
    /** 台位管理-台位区域 */
    CustomColumnEnum["LOCATION_TABLE_ZONE"] = "LOCATION_TABLE_ZONE";
    /** 服务费 */
    CustomColumnEnum["SERVICE_FEE"] = "SERVICE_FEE";
    /** 支付方式 */
    CustomColumnEnum["PAYMENT_METHOD"] = "PAYMENT_METHOD";
    /** 抵用券管理 */
    CustomColumnEnum["DISCOUNT_VOUCHER"] = "DISCOUNT_VOUCHER";
    /** 抵用券管理-门店详情 */
    CustomColumnEnum["DISCOUNT_VOUCHER_LOCATION_DETAIL"] = "DISCOUNT_VOUCHER_LOCATION_DETAIL";
    /** 必点菜 */
    CustomColumnEnum["PRODUCT_MUST_ORDER"] = "PRODUCT_MUST_ORDER";
    /** 常用备注 */
    CustomColumnEnum["POS_MEMO"] = "POS_MEMO";
    /** 票据样式设置-普通模板 */
    CustomColumnEnum["PRINT_TMPL_NORMAL"] = "PRINT_TMPL_NORMAL";
    /** 票据样式设置-高级模板 */
    CustomColumnEnum["PRINT_TMPL_ADVANCED"] = "PRINT_TMPL_ADVANCED";
    /** 票据样式设置-门店打印设置 */
    CustomColumnEnum["PRINT_TMPL_LOCATION"] = "PRINT_TMPL_LOCATION";
    /** 收银打印配置-总部规则 */
    CustomColumnEnum["CASHIER_PRINT_RULE_HEADQUARTERS"] = "CASHIER_PRINT_RULE_HEADQUARTERS";
    /** 收银打印配置-门店规则 */
    CustomColumnEnum["CASHIER_PRINT_RULE_LOCATION"] = "CASHIER_PRINT_RULE_LOCATION";
    /** 后厨出品档口-总部规则 */
    CustomColumnEnum["KITCHEN_PRINT_RULE_HEADQUARTERS"] = "KITCHEN_PRINT_RULE_HEADQUARTERS";
    /** 后厨出品档口-门店规则 */
    CustomColumnEnum["KITCHEN_PRINT_RULE_LOCATION"] = "KITCHEN_PRINT_RULE_LOCATION";
    /** 标签出品档口-总部规则 */
    CustomColumnEnum["LABEL_PRINT_RULE_HEADQUARTERS"] = "LABEL_PRINT_RULE_HEADQUARTERS";
    /** 标签出品档口-门店规则 */
    CustomColumnEnum["LABEL_PRINT_RULE_LOCATION"] = "LABEL_PRINT_RULE_LOCATION";
    /** 打印顺序-菜品类别 */
    CustomColumnEnum["POS_PRINT_SORT_PRODUCT_CATEGORY"] = "POS_PRINT_SORT_PRODUCT_CATEGORY";
    /** 打印顺序-菜品 */
    CustomColumnEnum["POS_PRINT_SORT_PRODUCT"] = "POS_PRINT_SORT_PRODUCT";
    /** 打印机管理-打印机 */
    CustomColumnEnum["PRINTER_MANAGEMENT_PRINTER"] = "PRINTER_MANAGEMENT_PRINTER";
    /** 打印机管理-云打印机 */
    CustomColumnEnum["PRINTER_MANAGEMENT_CLOUD_PRINTER"] = "PRINTER_MANAGEMENT_CLOUD_PRINTER";
    /** KDS设置 */
    CustomColumnEnum["KDS_SETTING"] = "KDS_SETTING";
    /** KDS设备管理 */
    CustomColumnEnum["KDS_DEVICE_MANAGEMENT"] = "KDS_DEVICE_MANAGEMENT";
    /** TV屏设备 */
    CustomColumnEnum["TV_SCREEN_DEVICE"] = "TV_SCREEN_DEVICE";
    /** 扫码买单 */
    CustomColumnEnum["SCAN_CODE_PAY"] = "SCAN_CODE_PAY";
    /** 辅屏设置-轮播图方案 */
    CustomColumnEnum["POS_SECOND_DISPLAY_CAROUSEL"] = "POS_SECOND_DISPLAY_CAROUSEL";
    /** TV屏装修-下发记录 */
    CustomColumnEnum["TV_SCREEN_DECORATION_ISSUE_RECORD"] = "TV_SCREEN_DECORATION_ISSUE_RECORD";
    /** 服务费统计 */
    CustomColumnEnum["SERVICE_FEE_STATISTICS_DAY"] = "SERVICE_FEE_STATISTICS_DAY";
    CustomColumnEnum["SERVICE_FEE_STATISTICS_MONTH"] = "SERVICE_FEE_STATISTICS_MONTH";
    CustomColumnEnum["SERVICE_FEE_STATISTICS_DAY_LOCATION"] = "SERVICE_FEE_STATISTICS_DAY_LOCATION";
    CustomColumnEnum["SERVICE_FEE_STATISTICS_MONTH_LOCATION"] = "SERVICE_FEE_STATISTICS_MONTH_LOCATION";
    CustomColumnEnum["SERVICE_FEE_STATISTICS_NONE"] = "SERVICE_FEE_STATISTICS_NONE";
    CustomColumnEnum["SERVICE_FEE_STATISTICS_ALL"] = "SERVICE_FEE_STATISTICS_ALL";
    CustomColumnEnum["KIT_ITEM"] = "KIT_ITEM";
    CustomColumnEnum["KIT_ITEM_RELATION"] = "KIT_ITEM_RELATION";
    CustomColumnEnum["FULL_GIFT_SUMMARY"] = "FULL_GIFT_SUMMARY";
    CustomColumnEnum["LIMITED_TIME_DISCOUNT_SUMMARY"] = "LIMITED_TIME_DISCOUNT_SUMMARY";
    CustomColumnEnum["DISCOUNT_FULL_REDUCE_SUMMARY"] = "DISCOUNT_FULL_REDUCE_SUMMARY";
    CustomColumnEnum["SALES_MANAGEMENT"] = "SALES_MANAGEMENT";
    /** 营业指标同环比 */
    CustomColumnEnum["BUSINESS_INDICATOR"] = "BUSINESS_INDICATOR";
    /** 商品概览 */
    CustomColumnEnum["PRODUCT_OVERVIEW_REPORT"] = "PRODUCT_OVERVIEW_REPORT";
    CustomColumnEnum["PRODUCT_OVERVIEW_REPORT_TYPE"] = "PRODUCT_OVERVIEW_REPORT_TYPE";
    CustomColumnEnum["PRODUCT_OVERVIEW_REPORT_ATTR"] = "PRODUCT_OVERVIEW_REPORT_ATTR";
    /** 储值分析 */
    CustomColumnEnum["DEPOSIT_ANALYSIS_DETAIL_LOCATION"] = "DEPOSIT_ANALYSIS_DETAIL_LOCATION";
    CustomColumnEnum["DEPOSIT_ANALYSIS_DETAIL_DATE"] = "DEPOSIT_ANALYSIS_DETAIL_DATE";
    CustomColumnEnum["DEPOSIT_ANALYSIS_DETAIL_LOCATION_DATE"] = "DEPOSIT_ANALYSIS_DETAIL_LOCATION_DATE";
    CustomColumnEnum["DEPOSIT_ANALYSIS_DETAIL_LOCATION_PAY_TYPE"] = "DEPOSIT_ANALYSIS_DETAIL_LOCATION_PAY_TYPE";
    /** 收银员统计 */
    CustomColumnEnum["CASHIER_STATISTICS"] = "CASHIER_STATISTICS";
    /** 报表中心-营业收款统计 */
    CustomColumnEnum["BUSINESS_COLLECTION_STATISTICS_CROSS_MAX_CATEGORY"] = "BUSINESS_COLLECTION_STATISTICS_CROSS_MAX_CATEGORY";
    CustomColumnEnum["BUSINESS_COLLECTION_STATISTICS_CROSS_MIN_CATEGORY"] = "BUSINESS_COLLECTION_STATISTICS_CROSS_MIN_CATEGORY";
    CustomColumnEnum["BUSINESS_COLLECTION_STATISTICS_VERTICAL_MAX_CATEGORY"] = "BUSINESS_COLLECTION_STATISTICS_VERTICAL_MAX_CATEGORY";
    CustomColumnEnum["BUSINESS_COLLECTION_STATISTICS_VERTICAL_MIN_CATEGORY"] = "BUSINESS_COLLECTION_STATISTICS_VERTICAL_MIN_CATEGORY";
    /** 报表中心-营业收款明细 */
    CustomColumnEnum["BUSINESS_RECEIPT_DETAIL"] = "BUSINESS_RECEIPT_DETAIL";
    /** 交班统计-支付统计 */
    CustomColumnEnum["HANDOVER_PAYMENT_STATISTICS"] = "HANDOVER_PAYMENT_STATISTICS";
    /** 渠道营业统计 */
    CustomColumnEnum["ORDER_BUSINESS_REPORT_ANALYSIS"] = "ORDER_BUSINESS_REPORT_ANALYSIS";
    /** 餐/时段营业统计 */
    CustomColumnEnum["SESSION_BUSINESS_STATISTICS"] = "SESSION_BUSINESS_STATISTICS";
    CustomColumnEnum["MEAL_SEGMENT_BUSINESS_STATISTICS"] = "MEAL_SEGMENT_BUSINESS_STATISTICS";
    /** 券收入统计 */
    CustomColumnEnum["TICKET_INCOME_STATISTICS"] = "TICKET_INCOME_STATISTICS";
    /** 快递商城统计 */
    CustomColumnEnum["ORDER_EXPRESS_SHOP_ANALYSIS"] = "ORDER_EXPRESS_SHOP_ANALYSIS";
    /** 报表中心-餐区/台位营业统计 */
    CustomColumnEnum["BUSINESS_ZONE_TABLE_STATISTICS"] = "BUSINESS_ZONE_TABLE_STATISTICS";
    CustomColumnEnum["BUSINESS_ZONE_TABLE_STATISTICS_TABLE"] = "BUSINESS_ZONE_TABLE_STATISTICS_TABLE";
    /** 报表中心-营业退款统计 */
    CustomColumnEnum["BUSINESS_REFUND_STATISTICS"] = "BUSINESS_REFUND_STATISTICS";
    /** 报表中心-订金/押金统计 */
    CustomColumnEnum["DOWN_PAYMENT_STATISTICS"] = "DOWN_PAYMENT_STATISTICS";
    /** 报表中心-挂账明细 */
    CustomColumnEnum["SIGN_REPAY_STATISTICS"] = "SIGN_REPAY_STATISTICS";
    /** 报表中心-营业优惠分析 */
    CustomColumnEnum["BUSINESS_DISCOUNT_ANALYZE"] = "BUSINESS_DISCOUNT_ANALYZE";
    /** 报表中心-营业收入构成 */
    CustomColumnEnum["BUSINESS_INCOME_PAYMENT"] = "BUSINESS_INCOME_PAYMENT";
    /** 报表中心-营业明细 */
    CustomColumnEnum["BUSINESS_DETAIL"] = "BUSINESS_DETAIL";
    /** 报表中心-营业外统计 */
    CustomColumnEnum["OUT_BUSINESS_STATISTICS"] = "OUT_BUSINESS_STATISTICS";
    /** 报表中心-会员储值明细 */
    CustomColumnEnum["CUSTOMER_STORE_VALUE_DETAIL"] = "CUSTOMER_STORE_VALUE_DETAIL";
    CustomColumnEnum["CUSTOMER_CROSS_LOCATION_CONSUME"] = "CUSTOMER_CROSS_LOCATION_CONSUME";
    CustomColumnEnum["CUSTOMER_CARD_TRADE_LOG"] = "CUSTOMER_CARD_TRADE_LOG";
    /** 报表中心-储值支付方式明细 */
    CustomColumnEnum["DEPOSIT_PAYMENT_TYPE_DETAIL"] = "DEPOSIT_PAYMENT_TYPE_DETAIL";
    /** 报表中心-储值分析 */
    CustomColumnEnum["DEPOSIT_ANALYSIS"] = "DEPOSIT_ANALYSIS";
    /** 报表中心-营业概览-支付统计 */
    CustomColumnEnum["BUSINESS_OVERVIEW_PAYMENT_STATISTICS"] = "BUSINESS_OVERVIEW_PAYMENT_STATISTICS";
    /** 报表中心-营业统计 */
    CustomColumnEnum["BUSINESS_STATISTICS"] = "BUSINESS_STATISTICS";
    /** 报表中心-商品门店销售汇总 */
    CustomColumnEnum["PRODUCT_LOCATION_SALE_SUMMARY"] = "PRODUCT_LOCATION_SALE_SUMMARY";
    /** 报表中心-退货/退菜报表 */
    CustomColumnEnum["PRODUCT_RETURN_AND_REFUND_STATISTICS"] = "PRODUCT_RETURN_AND_REFUND_STATISTICS";
    /** 报表中心-赠品统计报表 */
    CustomColumnEnum["GIFT_STATISTICS"] = "GIFT_STATISTICS";
    /** 报表中心-零销量菜品分析 */
    CustomColumnEnum["ZERO_SALE_PRODUCT_ANALYSIS"] = "ZERO_SALE_PRODUCT_ANALYSIS";
    /** 报表中心-菜品关联推荐 */
    CustomColumnEnum["PRODUCT_RELATION_RECOMMEND"] = "PRODUCT_RELATION_RECOMMEND";
    /** 报表中心-促销活动效果分析 */
    CustomColumnEnum["PROMOTION_ACTIVITY_EFFECT_ANALYSIS"] = "PROMOTION_ACTIVITY_EFFECT_ANALYSIS";
    /** 报表中心-营销活动效果分析 */
    CustomColumnEnum["MARKETING_ACTIVITY_EFFECT_ANALYSIS"] = "MARKETING_ACTIVITY_EFFECT_ANALYSIS";
    /** 报表中心-加料销售统计报表 */
    CustomColumnEnum["FEED_SALE_STATISTICS"] = "FEED_SALE_STATISTICS";
    /** 报表中心-做法统计报表 */
    CustomColumnEnum["METHOD_STATISTICS"] = "METHOD_STATISTICS";
    /** 报表中心-卡券销售明细 */
    CustomColumnEnum["BUSINESS_CARD_ORDER_DETAIL"] = "BUSINESS_CARD_ORDER_DETAIL";
    /** 交班统计 */
    CustomColumnEnum["SHIFT_HANDOVER_STATISTICS"] = "SHIFT_HANDOVER_STATISTICS";
    /** 虚拟物品 */
    CustomColumnEnum["VIRTUAL_ITEM"] = "VIRTUAL_ITEM";
    /** 虚拟物品管理实际物品 */
    CustomColumnEnum["VIRTUAL_ITEM_RELATION"] = "VIRTUAL_ITEM_RELATION";
    /** 库存调整原因 */
    CustomColumnEnum["ADJUSTMENT_REASON"] = "ADJUSTMENT_REASON";
    /** 调整单 */
    CustomColumnEnum["ADJUSTMENT_ORDER"] = "ADJUSTMENT_ORDER";
    /** 调整单详情 */
    CustomColumnEnum["ADJUSTMENT_ORDER_DETAIL"] = "ADJUSTMENT_ORDER_DETAIL";
    /** 盘点单 */
    CustomColumnEnum["CHECK_ORDER"] = "CHECK_ORDER";
    /** 盘点单详情 */
    CustomColumnEnum["CHECK_ORDER_DETAIL"] = "CHECK_ORDER_DETAIL";
    /** 库存成本调整 */
    CustomColumnEnum["COST_ADJUSTMENT_ORDER"] = "COST_ADJUSTMENT_ORDER";
    /** 库存成本调整详情 */
    CustomColumnEnum["COST_ADJUSTMENT_ORDER_DETAIL"] = "COST_ADJUSTMENT_ORDER_DETAIL";
    /** 内部申请单 */
    CustomColumnEnum["INNER_APPLY_ORDER"] = "INNER_APPLY_ORDER";
    /** 内部申请单详情 */
    CustomColumnEnum["INNER_APPLY_ORDER_DETAIL"] = "INNER_APPLY_ORDER_DETAIL";
    /** 物品库存查询 */
    CustomColumnEnum["INVENTORY_LEVEL"] = "INVENTORY_LEVEL";
    /** 库存转仓单 */
    CustomColumnEnum["INVENTORY_TRANSFER_ORDER"] = "INVENTORY_TRANSFER_ORDER";
    /** 库存转仓单详情 */
    CustomColumnEnum["INVENTORY_TRANSFER_ORDER_DETAIL"] = "INVENTORY_TRANSFER_ORDER_DETAIL";
    /** 物品查询模板 */
    CustomColumnEnum["ITEM_SEARCH_TEMPLATE"] = "ITEM_SEARCH_TEMPLATE";
    /** 物品角标 */
    CustomColumnEnum["ITEM_CORNER_MARK"] = "ITEM_CORNER_MARK";
    /** 采购收货单 */
    CustomColumnEnum["RECEIVE_ORDER"] = "RECEIVE_ORDER";
    /** 销售发货单 */
    CustomColumnEnum["WHOLESALE_DELIVERY_ORDER"] = "WHOLESALE_DELIVERY_ORDER";
    /** 销售发货单详情 */
    CustomColumnEnum["WHOLESALE_DELIVERY_ORDER_DETAIL"] = "WHOLESALE_DELIVERY_ORDER_DETAIL";
    /** 销售报价单 */
    CustomColumnEnum["WHOLESALE_QUOTE_ORDER"] = "WHOLESALE_QUOTE_ORDER";
    /** 销售报价单详情 */
    CustomColumnEnum["WHOLESALE_QUOTE_ORDER_DETAIL"] = "WHOLESALE_QUOTE_ORDER_DETAIL";
    /** 销售退货单 */
    CustomColumnEnum["WHOLESALE_RETURN_ORDER"] = "WHOLESALE_RETURN_ORDER";
    /** 销售退货单详情 */
    CustomColumnEnum["WHOLESALE_RETURN_ORDER_DETAIL"] = "WHOLESALE_RETURN_ORDER_DETAIL";
    /** 采购收货单详情 */
    CustomColumnEnum["RECEIVE_ORDER_DETAIL"] = "RECEIVE_ORDER_DETAIL";
    /** 要货单 */
    CustomColumnEnum["REQUEST_ORDER"] = "REQUEST_ORDER";
    /** 要货单详情 */
    CustomColumnEnum["REQUEST_ORDER_DETAIL"] = "REQUEST_ORDER_DETAIL";
    /** 调入单 */
    CustomColumnEnum["TRANSFER_IN_ORDER"] = "TRANSFER_IN_ORDER";
    /** 调入单详情 */
    CustomColumnEnum["TRANSFER_IN_ORDER_DETAIL"] = "TRANSFER_IN_ORDER_DETAIL";
    /** 调出单 */
    CustomColumnEnum["TRANSFER_OUT_ORDER"] = "TRANSFER_OUT_ORDER";
    /** 调出单详情 */
    CustomColumnEnum["TRANSFER_OUT_ORDER_DETAIL"] = "TRANSFER_OUT_ORDER_DETAIL";
    /** 配送中心-明细 */
    CustomColumnEnum["DISTRIBUTION_CENTER_DETAIL"] = "DISTRIBUTION_CENTER_DETAIL";
    /** 配送中心-汇总 */
    CustomColumnEnum["DISTRIBUTION_CENTER_BY_ITEM"] = "DISTRIBUTION_CENTER_BY_ITEM";
    /** 配送中心-门店物品汇总 */
    CustomColumnEnum["DISTRIBUTION_CENTER_BY_LOCATION_ITEM"] = "DISTRIBUTION_CENTER_BY_LOCATION_ITEM";
    /** 配送网络 */
    CustomColumnEnum["SHIP_NET"] = "SHIP_NET";
    /** 门店配送属性 */
    CustomColumnEnum["SHIP_PROP"] = "SHIP_PROP";
    CustomColumnEnum["SHIP_PRICE"] = "SHIP_PRICE";
    /** 物品采购属性 */
    CustomColumnEnum["PURCHASE_PROP"] = "PURCHASE_PROP";
    /** 订货控制 */
    CustomColumnEnum["REQUEST_RULE"] = "REQUEST_RULE";
    /** 要货模板 */
    CustomColumnEnum["REQUEST_TEMPLATE"] = "REQUEST_TEMPLATE";
    /** 采购订单 */
    CustomColumnEnum["PURCHASE_ORDER"] = "PURCHASE_ORDER";
    /** 采购订单详情 */
    CustomColumnEnum["PURCHASE_ORDER_DETAIL"] = "PURCHASE_ORDER_DETAIL";
    /** 直发单 */
    CustomColumnEnum["PURCHASE_ORDER_SHIPMENT"] = "PURCHASE_ORDER_SHIPMENT";
    /** 直发单详情 */
    CustomColumnEnum["PURCHASE_ORDER_SHIPMENT_DETAIL"] = "PURCHASE_ORDER_SHIPMENT_DETAIL";
    /** 退货单 */
    CustomColumnEnum["RETURN_ORDER"] = "RETURN_ORDER";
    /** 退货单详情 */
    CustomColumnEnum["RETURN_ORDER_DETAIL"] = "RETURN_ORDER_DETAIL";
    /** 物品供货关系 */
    CustomColumnEnum["ITEM_SUPPLY_RELATIONSHIP"] = "ITEM_SUPPLY_RELATIONSHIP";
    /** 生产计划单 */
    CustomColumnEnum["PRODUCE_PLAN_ORDER"] = "PRODUCE_PLAN_ORDER";
    /** 生产计划单详情 */
    CustomColumnEnum["PRODUCE_PLAN_ORDER_DETAIL"] = "PRODUCE_PLAN_ORDER_DETAIL";
    /** 生产领料单 */
    CustomColumnEnum["PRODUCE_MATERIAL_ORDER"] = "PRODUCE_MATERIAL_ORDER";
    /** 生产领料单详情 */
    CustomColumnEnum["PRODUCE_MATERIAL_ORDER_DETAIL"] = "PRODUCE_MATERIAL_ORDER_DETAIL";
    /** 生产入库单 */
    CustomColumnEnum["PRODUCE_STORAGE_ORDER"] = "PRODUCE_STORAGE_ORDER";
    /** 生产入库单详情 */
    CustomColumnEnum["PRODUCE_STORAGE_ORDER_DETAIL"] = "PRODUCE_STORAGE_ORDER_DETAIL";
    /** 加工品 */
    CustomColumnEnum["PRODUCE_ITEM"] = "PRODUCE_ITEM";
    /** 门店加工单 */
    CustomColumnEnum["PRODUCE_LOCATION_STORAGE_ORDER"] = "PRODUCE_LOCATION_STORAGE_ORDER";
    /** 物品在途-明细 */
    CustomColumnEnum["ITEM_IN_TRANSIT_DETAIL"] = "ITEM_IN_TRANSIT_DETAIL";
    /** 物品在途-按物品汇总 */
    CustomColumnEnum["ITEM_IN_TRANSIT_BY_ITEM"] = "ITEM_IN_TRANSIT_BY_ITEM";
    /** 物品在途-按门店汇总 */
    CustomColumnEnum["ITEM_IN_TRANSIT_BY_LOCATION"] = "ITEM_IN_TRANSIT_BY_LOCATION";
    /** 物品在途-按门店物品汇总 */
    CustomColumnEnum["ITEM_IN_TRANSIT_BY_LOCATION_ITEM"] = "ITEM_IN_TRANSIT_BY_LOCATION_ITEM";
    /** 物品在途-按单据汇总 */
    CustomColumnEnum["ITEM_IN_TRANSIT_BY_ORDER"] = "ITEM_IN_TRANSIT_BY_ORDER";
    /** 物品在途-按门店物品营业日汇总 */
    CustomColumnEnum["ITEM_IN_TRANSIT_BY_LOCATION_ITEM_BIZDAY"] = "ITEM_IN_TRANSIT_BY_LOCATION_ITEM_BIZDAY";
    /** 采购收货-明细 */
    CustomColumnEnum["PURCHASE_REPORT_RECEIVE_DETAIL"] = "PURCHASE_REPORT_RECEIVE_DETAIL";
    /** 采购退货-明细 */
    CustomColumnEnum["PURCHASE_REPORT_RETURN_DETAIL"] = "PURCHASE_REPORT_RETURN_DETAIL";
    /** 采购报表-按门店 */
    CustomColumnEnum["PURCHASE_REPORT_BY_LOCATION"] = "PURCHASE_REPORT_BY_LOCATION";
    /** 采购报表-按物品 */
    CustomColumnEnum["PURCHASE_REPORT_BY_ITEM"] = "PURCHASE_REPORT_BY_ITEM";
    /** 采购报表-按分类 */
    CustomColumnEnum["PURCHASE_REPORT_BY_TYPE"] = "PURCHASE_REPORT_BY_TYPE";
    /** 采购报表-按供应商汇总 */
    CustomColumnEnum["PURCHASE_REPORT_BY_SUPPLIER"] = "PURCHASE_REPORT_BY_SUPPLIER";
    /** 采购报表-按供应商-门店汇总 */
    CustomColumnEnum["PURCHASE_REPORT_BY_SUPPLIER_LOCATION"] = "PURCHASE_REPORT_BY_SUPPLIER_LOCATION";
    /** 采购报表-按供应商-物品汇总 */
    CustomColumnEnum["PURCHASE_REPORT_BY_SUPPLIER_ITEM"] = "PURCHASE_REPORT_BY_SUPPLIER_ITEM";
    /** 采购报表-按供应商-物品分类汇总 */
    CustomColumnEnum["PURCHASE_REPORT_BY_SUPPLIER_TYPE"] = "PURCHASE_REPORT_BY_SUPPLIER_TYPE";
    /** 供应商直发明细表 */
    CustomColumnEnum["PURCHASE_ORDER_REPORT_SUPPLIER_SHIPMENT_DETAIL"] = "PURCHASE_ORDER_REPORT_SUPPLIER_SHIPMENT_DETAIL";
    /** 出品率报表 */
    CustomColumnEnum["PRODUCE_FINISHED_RATE"] = "PRODUCE_FINISHED_RATE";
    /** 库存进出明细 */
    CustomColumnEnum["INVENTORY_LEVEL_LOG"] = "INVENTORY_LEVEL_LOG";
    /** 库存进出汇总 */
    CustomColumnEnum["INVENTORY_LEVEL_LOG_BY_ITEM"] = "INVENTORY_LEVEL_LOG_BY_ITEM";
    /** 库存入库汇总 */
    CustomColumnEnum["INVENTORY_LEVEL_LOG_BY_ITEM_IN"] = "INVENTORY_LEVEL_LOG_BY_ITEM_IN";
    /**库存进出明细按物品汇总_入库_门店-仓库物品汇总.*/
    CustomColumnEnum["INVENTORY_LEVEL_LOG_BY_ITEM_IN_LOCATION"] = "INVENTORY_LEVEL_LOG_BY_ITEM_IN_LOCATION";
    /**库存进出明细按物品汇总_出库_门店-仓库物品汇总.*/
    CustomColumnEnum["INVENTORY_LEVEL_LOG_BY_ITEM_OUT_LOCATION"] = "INVENTORY_LEVEL_LOG_BY_ITEM_OUT_LOCATION";
    /**库存进出明细按物品汇总-库存进出汇总_门店-仓库物品汇总.*/
    CustomColumnEnum["INVENTORY_LEVEL_LOG_BY_ITEM_LOCATION"] = "INVENTORY_LEVEL_LOG_BY_ITEM_LOCATION";
    /**进销存变动统计-物品汇总_门店-仓库物品汇总.*/
    CustomColumnEnum["INVENTORY_CHANGE_BY_ITEM_LOCATION"] = "INVENTORY_CHANGE_BY_ITEM_LOCATION";
    /** 库存出库汇总 */
    CustomColumnEnum["INVENTORY_LEVEL_LOG_BY_ITEM_OUT"] = "INVENTORY_LEVEL_LOG_BY_ITEM_OUT";
    /** 进销存变动统计-物品汇总 */
    CustomColumnEnum["INVENTORY_CHANGE_BY_ITEM"] = "INVENTORY_CHANGE_BY_ITEM";
    /** 损益报表-明细 */
    CustomColumnEnum["GAIN_LOSS_BY_DETAIL"] = "GAIN_LOSS_BY_DETAIL";
    /** 损益报表-物品 */
    CustomColumnEnum["GAIN_LOSS_BY_ITEM"] = "GAIN_LOSS_BY_ITEM";
    /** 损益报表-门店物品 */
    CustomColumnEnum["GAIN_LOSS_BY_LOCATION_ITEM"] = "GAIN_LOSS_BY_LOCATION_ITEM";
    /** 损益报表-门店仓库物品 */
    CustomColumnEnum["GAIN_LOSS_BY_LOCATION_STORE_ITEM"] = "GAIN_LOSS_BY_LOCATION_STORE_ITEM";
    /** 进销存变动统计-分类汇总 */
    CustomColumnEnum["INVENTORY_CHANGE_BY_TYPE"] = "INVENTORY_CHANGE_BY_TYPE";
    /** 进销存变动统计-门店汇总 */
    CustomColumnEnum["INVENTORY_CHANGE_BY_LOCATION"] = "INVENTORY_CHANGE_BY_LOCATION";
    /** 配送毛利-按门店 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_LOCATION"] = "SHIP_GROSS_PROFIT_BY_LOCATION";
    /** 配送毛利-按物品 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_ITEM"] = "SHIP_GROSS_PROFIT_BY_ITEM";
    /** 配送毛利-按门店物品 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_LOCATION_ITEM"] = "SHIP_GROSS_PROFIT_BY_LOCATION_ITEM";
    /** 配送毛利-按单据 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_ORDER"] = "SHIP_GROSS_PROFIT_BY_ORDER";
    /** 配送毛利-详情（单据-物品明细） */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_DETAIL"] = "SHIP_GROSS_PROFIT_BY_DETAIL";
    /** 配送毛利-按分类 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_TYPE"] = "SHIP_GROSS_PROFIT_BY_TYPE";
    /** 配送毛利-按门店分类 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_LOCATION_TYPE"] = "SHIP_GROSS_PROFIT_BY_LOCATION_TYPE";
    /** 配送毛利-按营业日 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_BIZDAY"] = "SHIP_GROSS_PROFIT_BY_BIZDAY";
    /** 配送毛利-门店仓库 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_LOCATION_STOREHOUSE_ITEM"] = "SHIP_GROSS_PROFIT_BY_LOCATION_STOREHOUSE_ITEM";
    /** 配送毛利-按门店仓库 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_LOCATION_STOREHOUSE"] = "SHIP_GROSS_PROFIT_BY_LOCATION_STOREHOUSE";
    /** 物品档案 */
    CustomColumnEnum["ITEM"] = "ITEM";
    /** 物品分类 */
    CustomColumnEnum["ITEM_TYPE"] = "ITEM_TYPE";
    /** 物品品牌 */
    CustomColumnEnum["ITEM_VENDOR"] = "ITEM_VENDOR";
    /** 供应商 */
    CustomColumnEnum["SUPPLIER"] = "SUPPLIER";
    /** 供应商用户 */
    CustomColumnEnum["SUPPLIER_USER"] = "SUPPLIER_USER";
    /** 供应商角色 */
    CustomColumnEnum["SUPPLIER_ROLE"] = "SUPPLIER_ROLE";
    /** 标准商品成本卡 */
    CustomColumnEnum["COST_CARD_OF_NORMAL"] = "COST_CARD_OF_NORMAL";
    /** 商场商品成本卡 */
    CustomColumnEnum["COST_CARD_OF_SHOP"] = "COST_CARD_OF_SHOP";
    /** 成本卡管理 */
    CustomColumnEnum["COST_CARD"] = "COST_CARD";
    /** 仓库档案 */
    CustomColumnEnum["STOREHOUSE"] = "STOREHOUSE";
    /** 仓库物品规则 */
    CustomColumnEnum["STOREHOUSE_ITEM_RULE"] = "STOREHOUSE_ITEM_RULE";
    /** 打印模板设置 */
    CustomColumnEnum["PRINT_DOCUMENT"] = "PRINT_DOCUMENT";
    /** 补货向导 */
    CustomColumnEnum["REQUEST_ORDER_GUIDE"] = "REQUEST_ORDER_GUIDE";
    /** 生产看板 */
    CustomColumnEnum["PRODUCE_BOARD"] = "PRODUCE_BOARD";
    /** 生产任务单 */
    CustomColumnEnum["PRODUCE_ORDER"] = "PRODUCE_TASK_ORDER";
    /** 生产看板领料单 */
    CustomColumnEnum["PRODUCE_BOARD_MATERIAL"] = "PRODUCE_BOARD_MATERIAL";
    /** 加工品原料耗用分析表 */
    CustomColumnEnum["PRODUCE_MATERIAL_CONSUMPTION"] = "PRODUCE_MATERIAL_CONSUMPTION";
    /** 应产率报表 */
    CustomColumnEnum["PRODUCE_ITEM_EXPECTED_RATE"] = "PRODUCE_ITEM_EXPECTED_RATE";
    /** 生产汇总表 */
    CustomColumnEnum["PRODUCE_ITEM_SUMMARY_REPORT"] = "PRODUCE_ITEM_EXPECTED_RATE";
    /** 生产人员生产汇总报表 */
    CustomColumnEnum["PRODUCE_STAFF_SUMMARY_REPORT"] = "PRODUCE_STAFF_SUMMARY_REPORT";
    /** 采购订单报表-明细 */
    CustomColumnEnum["PURCHASE_ORDER_REPORT_DETAIL"] = "PURCHASE_ORDER_REPORT_DETAIL";
    /** 采购订单报表-按订单汇总 */
    CustomColumnEnum["PURCHASE_ORDER_REPORT_BY_ORDER"] = "PURCHASE_ORDER_REPORT_BY_ORDER";
    /** 采购订单报表-按物品汇总 */
    CustomColumnEnum["PURCHASE_ORDER_REPORT_BY_ITEM"] = "PURCHASE_ORDER_REPORT_BY_ITEM";
    /** 采购订单报表-按供应商汇总 */
    CustomColumnEnum["PURCHASE_ORDER_REPORT_BY_SUPPLIER"] = "PURCHASE_ORDER_REPORT_BY_SUPPLIER";
    /** 进销存变动统计-门店-物品汇总 */
    CustomColumnEnum["INVENTORY_CHANGE_BY_LOCATION_ITEM"] = "INVENTORY_CHANGE_BY_LOCATION_ITEM";
    /** 进销存变动统计-门店-分类汇总 */
    CustomColumnEnum["INVENTORY_CHANGE_BY_LOCATION_TYPE"] = "INVENTORY_CHANGE_BY_LOCATION_TYPE";
    /** 效期汇总 */
    CustomColumnEnum["EXPIRY_BOARD_SUMMARY"] = "EXPIRY_BOARD_SUMMARY";
    /** 效期看板 */
    CustomColumnEnum["EXPIRY_BOARD"] = "EXPIRY_BOARD";
    /** 储存条件 */
    CustomColumnEnum["EXPIRY_STORE_CONDITION"] = "EXPIRY_STORE_CONDITION";
    /** 效期商品 */
    CustomColumnEnum["EXPIRY"] = "EXPIRY";
    /** 配送结算单 */
    CustomColumnEnum["INNER_SETTLE_ORDER"] = "INNER_SETTLE_ORDER";
    /** 配送结算详情 */
    CustomColumnEnum["INNER_SETTLE_ORDER_DETAIL"] = "INNER_SETTLE_ORDER_DETAIL";
    /** 门店往来账款，实收账款(汇总) */
    CustomColumnEnum["INNER_SETTLE_REPORT_BY_LOCATION"] = "INNER_SETTLE_REPORT_BY_LOCATION";
    /** 门店往来账款，实收账款(明细) */
    CustomColumnEnum["INNER_SETTLE_REPORT_BY_ORDER"] = "INNER_SETTLE_REPORT_BY_ORDER";
    /** 门店往来账款，期内应收账款(门店汇总) */
    CustomColumnEnum["INNER_SETTLE_REPORT_RECEIVABLE"] = "INNER_SETTLE_REPORT_RECEIVABLE";
    /** 门店往来账款，历史往来账款 */
    CustomColumnEnum["INNER_SETTLE_REPORT_HISTORY"] = "INNER_SETTLE_REPORT_HISTORY";
    /** 供应商预付 */
    CustomColumnEnum["SUPPLIER_PRE_PAY_ORDER"] = "SUPPLIER_PRE_PAY_ORDER";
    /** 供应商结算单 */
    CustomColumnEnum["SUPPLIER_SETTLE_ORDER"] = "SUPPLIER_SETTLE_ORDER";
    /** 供应商结算详情 */
    CustomColumnEnum["SUPPLIER_SETTLE_ORDER_DETAIL"] = "SUPPLIER_SETTLE_ORDER_DETAIL";
    /** 供应商往来账款，实收账款(汇总) */
    CustomColumnEnum["SUPPLIER_SETTLE_REPORT_BY_SUPPLIER"] = "SUPPLIER_SETTLE_REPORT_BY_SUPPLIER";
    /** 供应商往来账款，实收账款(明细) */
    CustomColumnEnum["SUPPLIER_SETTLE_REPORT_BY_ORDER"] = "SUPPLIER_SETTLE_REPORT_BY_ORDER";
    /** 供应商往来账款，期内应收账款(门店汇总) */
    CustomColumnEnum["SUPPLIER_SETTLE_REPORT_PERIOD"] = "SUPPLIER_SETTLE_REPORT_PERIOD";
    /** 供应商往来账款，历史往来账款 */
    CustomColumnEnum["SUPPLIER_SETTLE_REPORT_HISTORY"] = "SUPPLIER_SETTLE_REPORT_HISTORY";
    /** 门店预收 */
    CustomColumnEnum["INNER_PRE_PAY_ORDER"] = "INNER_PRE_PAY_ORDER";
    /** 供应商预付汇总 */
    CustomColumnEnum["SUPPLIER_PRE_PAY_SUMMARY"] = "SUPPLIER_PRE_PAY_SUMMARY";
    /** 门店预收汇总 */
    CustomColumnEnum["INNER_PRE_PAY_SUMMARY"] = "INNER_PRE_PAY_SUMMARY";
    /** 费用项目 */
    CustomColumnEnum["STOCK_FEE_ITEM"] = "STOCK_FEE_ITEM";
    /** 门店费用单 */
    CustomColumnEnum["INNER_FEE_ORDER"] = "INNER_FEE_ORDER";
    /** 门店费用汇总 */
    CustomColumnEnum["INNER_FEE_SUMMARY"] = "INNER_FEE_SUMMARY";
    /** 供应商费用单 */
    CustomColumnEnum["SUPPLIER_FEE_ORDER"] = "SUPPLIER_FEE_ORDER";
    /** 供应商费用汇总 */
    CustomColumnEnum["SUPPLIER_FEE_SUMMARY"] = "SUPPLIER_FEE_SUMMARY";
    /** 批量生成调出单 */
    CustomColumnEnum["TRANSFER_OUT_ORDER_BATCH_SAVE"] = "TRANSFER_OUT_ORDER_BATCH_SAVE";
    /** 商品毛利分析表 */
    CustomColumnEnum["PRODUCT_VARIANT_GROSS_PROFIT"] = "PRODUCT_VARIANT_GROSS_PROFIT";
    /** 门店毛利分析表 */
    CustomColumnEnum["PRODUCT_VARIANT_GROSS_PROFIT_BY_LOCATION"] = "PRODUCT_VARIANT_GROSS_PROFIT_BY_LOCATION";
    /** 门店商品毛利对比表 */
    CustomColumnEnum["PRODUCT_VARIANT_GROSS_PROFIT_COMPARISON"] = "PRODUCT_VARIANT_GROSS_PROFIT_COMPARISON";
    /** 商品成本明细 */
    CustomColumnEnum["PRODUCT_VARIANT_COST_DETAIL"] = "PRODUCT_VARIANT_COST_DETAIL";
    /**商品汇总 */
    CustomColumnEnum["PRODUCT_SUMMARY"] = "PRODUCT_SUMMARY";
    /**商品销售汇总 */
    CustomColumnEnum["PRODUCT_SALE_SUMMARY"] = "PRODUCT_SALE_SUMMARY";
    /**商品销售明细 */
    CustomColumnEnum["PRODUCT_SALE_DETAIL"] = "PRODUCT_SALE_DETAIL";
    /**商品销售排行 */
    CustomColumnEnum["PRODUCT_SALE_RANK"] = "PRODUCT_SALE_RANK";
    /**会员扣款记录 */
    CustomColumnEnum["CUSTOMER_CONSUME_DETAIL"] = "CUSTOMER_CONSUME_DETAIL";
    /**类别销售排行 */
    CustomColumnEnum["PRODUCT_TYPE_SALE_RANK"] = "PRODUCT_TYPE_SALE_RANK";
    /** 套餐销售排行-套餐维度 */
    CustomColumnEnum["KIT_SALE_STATISTICS_KIT_DIMENSION"] = "KIT_SALE_STATISTICS_KIT_DIMENSION";
    /** 套餐销售排行-套餐商品维度 */
    CustomColumnEnum["KIT_SALE_STATISTICS_KIT_DETAIL_DIMENSION"] = "KIT_SALE_STATISTICS_KIT_DETAIL_DIMENSION";
    /**原材料销售消耗报表 */
    CustomColumnEnum["MATERIAL_SALE_INVENTORY_ANALYSIS"] = "MATERIAL_SALE_INVENTORY_ANALYSIS";
    /**餐/时端商品统计 */
    CustomColumnEnum["MEAL_SEGMENT_PRODUCT_STATISTICS"] = "MEAL_SEGMENT_PRODUCT_STATISTICS";
    /** 销售员统计 */
    CustomColumnEnum["SALESPERSON_STATISTICS"] = "SALESPERSON_STATISTICS";
    /**商品成本毛利 */
    CustomColumnEnum["PRODUCT_COST_GROSS"] = "PRODUCT_COST_GROSS";
    /**订单评价-订单级评价 */
    CustomColumnEnum["ORDER_LEVEL_EVALUATION"] = "ORDER_LEVEL_EVALUATION";
    /**订单评价-商品级评价 */
    CustomColumnEnum["PRODUCT_LEVEL_EVALUATION"] = "PRODUCT_LEVEL_EVALUATION";
    /** 评价分析-到店自提 */
    CustomColumnEnum["COMMENTS_ANALYSIS_SELF_PICK"] = "COMMENTS_ANALYSIS_SELF_PICK";
    /** 评价分析-本地配送 */
    CustomColumnEnum["COMMENTS_ANALYSIS_LOCAL_DELIVERY"] = "COMMENTS_ANALYSIS_LOCAL_DELIVERY";
    /** 评价设置 */
    CustomColumnEnum["COMMENT_SCHEMES"] = "COMMENT_SCHEMES";
    /** 素材库-视频 */
    CustomColumnEnum["PROFILE_FILE_LIBRARIES_VIDEO"] = "PROFILE_FILE_LIBRARIES_VIDEO";
    /** 订金/押金 */
    CustomColumnEnum["DOWN_PAYMENT"] = "DOWN_PAYMENT";
    /** 桌台预订 */
    CustomColumnEnum["TABLE_ORDER"] = "TABLE_ORDER";
    /** 自动标签 */
    CustomColumnEnum["CUSTOMER_TAG_AUTOMATION"] = "CUSTOMER_TAG_AUTOMATION";
    /** 手动标签 */
    CustomColumnEnum["CUSTOMER_TAG_MANUAL"] = "CUSTOMER_TAG_MANUAL";
    /** 订单 */
    CustomColumnEnum["ORDER"] = "ORDER";
    CustomColumnEnum["DINNER_ORDER"] = "DINNER_ORDER";
    /**商品管理-单位 */
    CustomColumnEnum["PRODUCT_UNIT"] = "PRODUCT_UNIT";
    /**商品管理-商品角标 */
    CustomColumnEnum["PRODUCT_CORNER_MARK"] = "PRODUCT_CORNER_MARK";
    /**商品管理-类别角标 */
    CustomColumnEnum["PRODUCT_TYPE_CORNER_MARK"] = "PRODUCT_TYPE_CORNER_MARK";
    /**商品管理-属性 */
    CustomColumnEnum["PRODUCT_PROPERTY"] = "PRODUCT_PROPERTY";
    /**商品管理-属性库 */
    CustomColumnEnum["NORMAL_LOCATION_PRODUCT_PROPERTY"] = "NORMAL_LOCATION_PRODUCT_PROPERTY";
    /**商品管理-库存 */
    CustomColumnEnum["PRODUCT_INVENTORY"] = "PRODUCT_INVENTORY";
    /**商品管理-虚拟库存 */
    CustomColumnEnum["PRODUCT_VIRTUAL_INVENTORY"] = "PRODUCT_VIRTUAL_INVENTORY";
    /** 会员卡-卡类型 */
    CustomColumnEnum["CUSTOMER_CARD_TMPL"] = "CUSTOMER_CARD_TMPL";
    /** 会员卡-共享分组 */
    CustomColumnEnum["CUSTOMER_CARD_SHARE_GROUP"] = "CUSTOMER_CARD_SHARE_GROUP";
    /** 会员卡-卡列表 */
    CustomColumnEnum["CUSTOMER_CARD"] = "CUSTOMER_CARD";
    /** 预储值页 */
    CustomColumnEnum["PRE_DEPOSIT_LIST"] = "PRE_DEPOSIT_LIST";
    /** 预储值记录 */
    CustomColumnEnum["PRE_DEPOSIT_LOG_LIST"] = "PRE_DEPOSIT_LOG_LIST";
    /** 满X件Y折-汇总 */
    CustomColumnEnum["SECOND_HALF_DISCOUNT_SUMMARY"] = "SECOND_HALF_DISCOUNT_SUMMARY";
    CustomColumnEnum["SELF_PICK_ORDER"] = "SELF_PICK_ORDER";
    CustomColumnEnum["PLATFORM_ORDER"] = "PLATFORM_ORDER";
    /** 平台门店 */
    CustomColumnEnum["PLATFORM_MINI_PROGRAM_STORE_LIST"] = "PLATFORM_MINI_PROGRAM_STORE_LIST";
    /** 平台商品审核 */
    CustomColumnEnum["PRODUCT_AUDIT"] = "PRODUCT_AUDIT";
    /** 快递模板 */
    CustomColumnEnum["EXPRESS_TMPL"] = "EXPRESS_TMPL";
    /** 聚合订单 */
    CustomColumnEnum["AGGREGATE_DELIVERY_ORDER"] = "AGGREGATE_DELIVERY_ORDER";
    /** 聚合配送 */
    CustomColumnEnum["AGGREGATE_DELIVERY_LOCATION_CONFIG"] = "AGGREGATE_DELIVERY_LOCATION_CONFIG";
    /** 二维码管理-台位码 */
    CustomColumnEnum["TABLE_ORDER_CODE"] = "TABLE_ORDER_CODE";
    /** 二维码管理-空码 */
    CustomColumnEnum["CREATE_EMPTY_CODE"] = "CREATE_EMPTY_CODE";
    CustomColumnEnum["PRODUCT_RESERVE_ORDER"] = "PRODUCT_RESERVE_ORDER";
    CustomColumnEnum["SHOP_ORDER"] = "SHOP_ORDER";
    CustomColumnEnum["SCAN_CODE_ORDER"] = "SCAN_CODE_ORDER";
    CustomColumnEnum["STANDARD_PRODUCT"] = "STANDARD_PRODUCT";
    /** 客户管理-列表 */
    CustomColumnEnum["CUSTOMER_LIST"] = "CUSTOMER_LIST";
    /**出品部门-总部 */
    CustomColumnEnum["PRODUCTION_DEPARTMENT_HEADQUARTER"] = "PRODUCTION_DEPARTMENT_HEADQUARTER";
    /**出品部门-门店 */
    CustomColumnEnum["PRODUCTION_DEPARTMENT_LOCATION"] = "PRODUCTION_DEPARTMENT_LOCATION";
    /** 异常订单-接单异常 */
    CustomColumnEnum["ORDER_RECEIVING_EXCEPTION"] = "ORDER_RECEIVING_EXCEPTION";
    /** 异常订单-配送异常 */
    CustomColumnEnum["DISTRIBUTION_ANOMALY"] = "DISTRIBUTION_ANOMALY";
    /** 异常订单-支付异常 */
    CustomColumnEnum["ABNORMAL_PAYMENT"] = "ABNORMAL_PAYMENT";
    /** 异常订单-储值异常 */
    CustomColumnEnum["DEPOSIT_EXCEPTION"] = "DEPOSIT_EXCEPTION";
    /** 营销管理-共享互斥 */
    CustomColumnEnum["EXCLUSIVE_SHARE"] = "EXCLUSIVE_SHARE";
    /** 卡券订单 */
    CustomColumnEnum["CARD_ORDERS"] = "CARD_ORDERS";
    /** 售后订单 */
    CustomColumnEnum["AFTER_SALE_ORDERS"] = "AFTER_SALE_ORDERS";
    CustomColumnEnum["SUGGESTION_FEEDBACK"] = "SUGGESTION_FEEDBACK";
    /** 卡券售后订单 */
    CustomColumnEnum["AFTER_SALE_CARD_ORDER"] = "AFTER_SALE_CARD_ORDER";
    CustomColumnEnum["GIFT_CARD_INFO"] = "GIFT_CARD_INFO";
    /** 门店商品 */
    CustomColumnEnum["NORMAL_LOCATION_PRODUCT"] = "NORMAL_LOCATION_PRODUCT";
    /** 门店套餐 */
    CustomColumnEnum["NORMAL_LOCATION_PRODUCT_KIT"] = "NORMAL_LOCATION_PRODUCT_KIT";
    /** 套餐 */
    CustomColumnEnum["PACKAGEP_RODUCT"] = "PACKAGEP_RODUCT";
    /** 商城商品 */
    CustomColumnEnum["MALL_PRODUCT"] = "MALL_PRODUCT";
    /** 折扣减免-单品折扣 */
    CustomColumnEnum["DISCOUNT_REDUCTION_SINGLE_ITEM"] = "DISCOUNT_REDUCTION_SINGLE_ITEM";
    /** 折扣减免-整单折扣 */
    CustomColumnEnum["DISCOUNT_REDUCTION_WHOLE_ORDER"] = "DISCOUNT_REDUCTION_WHOLE_ORDER";
    /** 满减满折 */
    CustomColumnEnum["FULL_REDUCE"] = "FULL_REDUCE";
    /** 限时折扣 */
    CustomColumnEnum["LIMITED_TIME_DISCOUNT"] = "LIMITED_TIME_DISCOUNT";
    /** 满X件Y折 */
    CustomColumnEnum["SECOND_HALF_DISCOUNT"] = "SECOND_HALF_DISCOUNT";
    /** 满赠 */
    CustomColumnEnum["FULL_GIFT"] = "FULL_GIFT";
    /** 加价购 */
    CustomColumnEnum["MARK_UP_PURCHASE"] = "MARK_UP_PURCHASE";
    /** 减运费 */
    CustomColumnEnum["FREIGHT_REDUCE"] = "FREIGHT_REDUCE";
    /** N元任选 */
    CustomColumnEnum["ANY_CHOICE"] = "ANY_CHOICE";
    /** 随机立减 */
    CustomColumnEnum["RANDOM_REDUCE"] = "RANDOM_REDUCE";
    /** 优惠买单 */
    CustomColumnEnum["PREFERENTIAL_PAY"] = "PREFERENTIAL_PAY";
    /** 促销活动管理  */
    CustomColumnEnum["PROMOTION_ACTIVITY_MGR"] = "PROMOTION_ACTIVITY_MGR";
    CustomColumnEnum["WESTORE_LOCATION_PRODUCT"] = "WESTORE_LOCATION_PRODUCT";
    /** 微信小程序推广 */
    CustomColumnEnum["MINI_PROGRAM_PROMOTION"] = "MINI_PROGRAM_PROMOTION";
    /** 微信小程序用户协议 */
    CustomColumnEnum["USER_AGREEMENT"] = "USER_AGREEMENT";
    CustomColumnEnum["IC_CARD_LIST"] = "IC_CARD_LIST";
    /** 企微-渠道活码 */
    CustomColumnEnum["WECOM_CHANNEL_CODE"] = "WECOM_CHANNEL_CODE";
    /** 企微-社群活码 */
    CustomColumnEnum["WECOM_GROUP_CODE"] = "WECOM_GROUP_CODE";
    /** 企微-LBS加好友 */
    CustomColumnEnum["WECOM_LBS_FRIEND"] = "WECOM_LBS_FRIEND";
    /** 企微-LBS引流入群 */
    CustomColumnEnum["WECOM_LBS_GROUP"] = "WECOM_LBS_GROUP";
    /** 企微-群欢迎语 */
    CustomColumnEnum["WECOM_GROUP_GREET"] = "WECOM_GROUP_GREET";
    /** 企微-客户群发-立即发送 */
    CustomColumnEnum["WECOM_CUSTOMER_GROUP_SEND_INSTANT"] = "WECOM_CUSTOMER_GROUP_SEND_INSTANT";
    /** 企微-客户群发-定时发送 */
    CustomColumnEnum["WECOM_CUSTOMER_GROUP_SEND_SCHEDULED"] = "WECOM_CUSTOMER_GROUP_SEND_SCHEDULED";
    /** 企微-客户群发-周期发送 */
    CustomColumnEnum["WECOM_CUSTOMER_GROUP_SEND_CYCLIC"] = "WECOM_CUSTOMER_GROUP_SEND_CYCLIC";
    /** 企微-社群群发-立即发送 */
    CustomColumnEnum["WECOM_GROUP_GROUP_SEND_INSTANT"] = "WECOM_GROUP_GROUP_SEND_INSTANT";
    /** 企微-社群群发-定时发送 */
    CustomColumnEnum["WECOM_GROUP_GROUP_SEND_SCHEDULED"] = "WECOM_GROUP_GROUP_SEND_SCHEDULED";
    /** 企微-社群群发-周期发送 */
    CustomColumnEnum["WECOM_GROUP_GROUP_SEND_CYCLIC"] = "WECOM_GROUP_GROUP_SEND_CYCLIC";
    /** 企微-群发助手-立即发送 */
    CustomColumnEnum["WECOM_GROUP_SEND_ASSISTANT_INSTANT"] = "WECOM_GROUP_SEND_ASSISTANT_INSTANT";
    /** 企微-群发助手-定时发送 */
    CustomColumnEnum["WECOM_GROUP_SEND_ASSISTANT_SCHEDULED"] = "WECOM_GROUP_SEND_ASSISTANT_SCHEDULED";
    /** 企微-群发助手-周期发送 */
    CustomColumnEnum["WECOM_GROUP_SEND_ASSISTANT_CYCLIC"] = "WECOM_GROUP_SEND_ASSISTANT_CYCLIC";
    /** 企微-素材库-文本 */
    CustomColumnEnum["WECOM_MATERIAL_TEXT"] = "WECOM_MATERIAL_TEXT";
    /** 企微-素材库-图片 */
    CustomColumnEnum["WECOM_MATERIAL_IMAGE"] = "WECOM_MATERIAL_IMAGE";
    /** 企微-素材库-视频 */
    CustomColumnEnum["WECOM_MATERIAL_VIDEO"] = "WECOM_MATERIAL_VIDEO";
    /** 企微-素材库-小程序 */
    CustomColumnEnum["WECOM_MATERIAL_MINI_APP"] = "WECOM_MATERIAL_MINI_APP";
    /** 企微-素材库-链接 */
    CustomColumnEnum["WECOM_MATERIAL_LINK"] = "WECOM_MATERIAL_LINK";
    /** 企微-客户列表 */
    CustomColumnEnum["WECOM_CUSTOMER_LIST"] = "WECOM_CUSTOMER_LIST";
    /** 企微-客户群 */
    CustomColumnEnum["WECOM_CUSTOMER_GROUP"] = "WECOM_CUSTOMER_GROUP";
    /** 企微-标签管理 */
    CustomColumnEnum["WECOM_TAG_MGR"] = "WECOM_TAG_MGR";
    /** 企微-社群标签 */
    CustomColumnEnum["WECOM_GROUP_TAG"] = "WECOM_GROUP_TAG";
    /** 企微-群主管理 */
    CustomColumnEnum["WECOM_GROUP_OWNER"] = "WECOM_GROUP_OWNER";
    /** 企微-企微角色管理 */
    CustomColumnEnum["WECOM_ROLE"] = "WECOM_ROLE";
    /** 企微-员工管理 */
    CustomColumnEnum["WECOM_USER"] = "WECOM_USER";
    /** 企微-员工接口管理-员工信息 */
    CustomColumnEnum["WECOM_USER_LICENSE"] = "WECOM_USER_LICENSE";
    /** 企微-员工接口管理-账号信息 */
    CustomColumnEnum["WECOM_USER_LICENSE_DETAIL"] = "WECOM_USER_LICENSE_DETAIL";
    /** 三方券核销记录 */
    CustomColumnEnum["VIRTUAL_TICKET_VERIFY_RECORD"] = "VIRTUAL_TICKET_VERIFY_RECORD";
    /** 支付宝神券-门店列表 */
    CustomColumnEnum["ALIPAY_COUPON_STORE"] = "ALIPAY_COUPON_STORE";
    /** 支付宝神券-团购项目列表 */
    CustomColumnEnum["ALIPAY_COUPON_TICKET"] = "ALIPAY_COUPON_TICKET";
    /** 支付宝神券-下发记录列表 */
    CustomColumnEnum["ALIPAY_COUPON_ISSUE_RECORD"] = "ALIPAY_COUPON_ISSUE_RECORD";
    /** 美团团购券 */
    CustomColumnEnum["MT_TUANGOU_TICKET"] = "MT_TUANGOU_TICKET";
    /** 抖音团购券-门店授权 */
    CustomColumnEnum["TIKTOK_TUANGOU_TICKET_LOCATION_AUTHORIZATION"] = "TIKTOK_TUANGOU_TICKET_LOCATION_AUTHORIZATION";
    /** 抖音团购券-兑换记录 */
    CustomColumnEnum["TIKTOK_TUANGOU_TICKET_EXCHANGE_RECORD"] = "TIKTOK_TUANGOU_TICKET_EXCHANGE_RECORD";
    /** 口碑团购券 */
    CustomColumnEnum["KOU_BEI_TUANGOU_TICKET"] = "KOU_BEI_TUANGOU_TICKET";
    /** 快手团购券 */
    CustomColumnEnum["KS_TUANGOU_TICKET"] = "KS_TUANGOU_TICKET";
    /** 三方对账明细 */
    CustomColumnEnum["OMS_RECONCILE_DETAIL"] = "OMS_RECONCILE_DETAIL";
    /** 三方对账结果汇总 */
    CustomColumnEnum["OMS_RECONCILE_SUMMARY"] = "OMS_RECONCILE_SUMMARY";
    /** 美团外卖门店列表 */
    CustomColumnEnum["MT_STORE_LIST"] = "MT_STORE_LIST";
    /** 美团外卖门店商品 */
    CustomColumnEnum["MT_PRODUCT_LIST"] = "MT_PRODUCT_LIST";
    /** 淘宝闪购·餐饮门店列表 */
    CustomColumnEnum["EL_STORE_LIST"] = "EL_STORE_LIST";
    /** 淘宝闪购·餐饮门店商品 */
    CustomColumnEnum["EL_PRODUCT_LIST"] = "EL_PRODUCT_LIST";
    /** 淘宝闪购·零售门店列表 */
    CustomColumnEnum["EB_STORE_LIST"] = "EB_STORE_LIST";
    /** 淘宝闪购·零售门店商品 */
    CustomColumnEnum["EB_PRODUCT_LIST"] = "EB_PRODUCT_LIST";
    /** 抖音外卖门店列表 */
    CustomColumnEnum["TIKTOK_STORE_LIST"] = "TIKTOK_STORE_LIST";
    /** 抖音外卖门店商品 */
    CustomColumnEnum["TIKTOK_PRODUCT_LIST"] = "TIKTOK_PRODUCT_LIST";
    /** 抖音自助核销门店列表 */
    CustomColumnEnum["TIKTOK_SELF_CHECK_STORE_LIST"] = "TIKTOK_SELF_CHECK_STORE_LIST";
    /** 抖音自助核销门店商品 */
    CustomColumnEnum["TIKTOK_SELF_CHECK_PRODUCT_LIST"] = "TIKTOK_SELF_CHECK_PRODUCT_LIST";
    /** 京东秒送门店列表 */
    CustomColumnEnum["JD_STORE_LIST"] = "JD_STORE_LIST";
    /** 京东秒送门店商品 */
    CustomColumnEnum["JD_PRODUCT_LIST"] = "JD_PRODUCT_LIST";
    /** 美团闪购门店列表 */
    CustomColumnEnum["MTSG_STORE_LIST"] = "MTSG_STORE_LIST";
    /** 美团闪购门店商品 */
    CustomColumnEnum["MTSG_PRODUCT_LIST"] = "MTSG_PRODUCT_LIST";
    /** 门店品牌 */
    CustomColumnEnum["LOCATION_BRAND"] = "LOCATION_BRAND";
    /** 操作日志 */
    CustomColumnEnum["SYSTEM_LOG_WEB"] = "SYSTEM_LOG_WEB";
    CustomColumnEnum["SYSTEM_LOG_POS"] = "SYSTEM_LOG_POS";
    CustomColumnEnum["SYSTEM_LOG_APP"] = "SYSTEM_LOG_APP";
    CustomColumnEnum["POS_SENSITIVE_OPERATE_STATISTICS"] = "POS_SENSITIVE_OPERATE_STATISTICS";
    CustomColumnEnum["PRODUCT_CLEARANCE_OPERATE_LOG"] = "PRODUCT_CLEARANCE_OPERATE_LOG";
    /** 断货分析 */
    CustomColumnEnum["STOCK_INTERRUPT"] = "STOCK_INTERRUPT";
    /** 库存预警 */
    CustomColumnEnum["STOCK_WARN"] = "STOCK_WARN";
    /** 财务中心-门店子商户设置 */
    CustomColumnEnum["LOCATION_SUB_MERCHANT_CONFIG"] = "LOCATION_SUB_MERCHANT_CONFIG";
    /** 财务中心-提现记录 */
    CustomColumnEnum["WITHDRAW_ORDER"] = "WITHDRAW_ORDER";
    /** 超量折扣 */
    CustomColumnEnum["EXCEED_DISCOUNT_ORDER"] = "EXCEED_DISCOUNT_ORDER";
    /** 门店管理 */
    CustomColumnEnum["LOCATION"] = "LOCATION";
    /** 门店标签 */
    CustomColumnEnum["LOCATION_TAG"] = "LOCATION_TAG";
    /** 门店复制 */
    CustomColumnEnum["LOCATION_DUPLICATE"] = "LOCATION_DUPLICATE";
    /** 用户管理 */
    CustomColumnEnum["STAFF"] = "STAFF";
    /** 用户角色 */
    CustomColumnEnum["STAFF_ROLE"] = "STAFF_ROLE";
    /** 员工管理 */
    CustomColumnEnum["POS_STAFF"] = "POS_STAFF";
    /** 员工角色 */
    CustomColumnEnum["POS_STAFF_ROLE"] = "POS_STAFF_ROLE";
    /** 销售员 */
    CustomColumnEnum["POS_SALESMAN"] = "POS_SALESMAN";
    /** 三方订单分析 */
    CustomColumnEnum["THREE_PARTY_ORDER_ANALYSIS_STATISTICS"] = "THREE_PARTY_ORDER_ANALYSIS_STATISTICS";
    /** 客单分析报表 */
    CustomColumnEnum["CUSTOMER_ORDER_PRICE_ANALYSIS"] = "CUSTOMER_ORDER_PRICE_ANALYSIS";
    /** 配送跟踪-要货单状态 */
    CustomColumnEnum["TRANSFER_REPORT_TRACK_REQUEST_STATUS"] = "TRANSFER_REPORT_TRACK_REQUEST_STATUS";
    /** 配送跟踪-到货率分析 */
    CustomColumnEnum["TRANSFER_REPORT_TRACK_ARRIVAL_RATE"] = "TRANSFER_REPORT_TRACK_ARRIVAL_RATE";
    /** 配送跟踪-门店要货汇总 */
    CustomColumnEnum["TRANSFER_REPORT_TRACK_LOCATION_SUMMARY"] = "TRANSFER_REPORT_TRACK_LOCATION_SUMMARY";
    /** 会员卡操作明细 */
    CustomColumnEnum["CUSTOMER_CARD_OPERATE_LOG"] = "CUSTOMER_CARD_OPERATE_LOG";
    /** 储值活动效果分析 */
    CustomColumnEnum["DEPOSIT_ACTIVITY_ANALYSIS_STATISTICS"] = "DEPOSIT_ACTIVITY_ANALYSIS_STATISTICS";
    /** 物品改价记录 */
    CustomColumnEnum["ITEM_PRICE_LOG"] = "ITEM_PRICE_LOG";
    /** 商户支付-交易汇总 */
    CustomColumnEnum["PAYMENT_TRANSACTION_SUMMARY"] = "PAYMENT_TRANSACTION_SUMMARY";
    /** 商户支付-退款记录 */
    CustomColumnEnum["PAYMENT_REFUND_RECORD"] = "PAYMENT_REFUND_RECORD";
    /** 商户支付-支付记录 */
    CustomColumnEnum["PAYMENT_PAYMENT_RECORD"] = "PAYMENT_PAYMENT_RECORD"; /** POS门店商品 */
    /** 平台小程序支付-交易汇总 */
    CustomColumnEnum["PLATFORM_MINI_PROGRAM_PAYMENT_TRANSACTION_SUMMARY"] = "PLATFORM_MINI_PROGRAM_PAYMENT_TRANSACTION_SUMMARY";
    /** 平台小程序支付-退款记录 */
    CustomColumnEnum["PLATFORM_MINI_PROGRAM_PAYMENT_REFUND_RECORD"] = "PLATFORM_MINI_PROGRAM_PAYMENT_REFUND_RECORD";
    /** 平台小程序支付-支付记录 */
    CustomColumnEnum["PLATFORM_MINI_PROGRAM_PAYMENT_PAYMENT_RECORD"] = "PLATFORM_MINI_PROGRAM_PAYMENT_PAYMENT_RECORD";
    /** 储值消费分账结算单查询 */
    CustomColumnEnum["FINANCE_DEPOSIT_CONSUME_ACCOUNT_SPLIT_SETTLEMENT"] = "FINANCE_DEPOSIT_CONSUME_ACCOUNT_SPLIT_SETTLEMENT";
    /** 储值消费分账结算单-批次查询 */
    CustomColumnEnum["FINANCE_DEPOSIT_CONSUME_ACCOUNT_SPLIT_SETTLEMENT_BATCH"] = "FINANCE_DEPOSIT_CONSUME_ACCOUNT_SPLIT_SETTLEMENT_BATCH";
    /** 礼品卡消费分账结算单查询 */
    CustomColumnEnum["FINANCE_GIFT_CARD_CONSUME_ACCOUNT_SPLIT_SETTLEMENT"] = "FINANCE_GIFT_CARD_CONSUME_ACCOUNT_SPLIT_SETTLEMENT";
    /** 礼品卡消费分账结算单-批次查询 */
    CustomColumnEnum["FINANCE_GIFT_CARD_CONSUME_ACCOUNT_SPLIT_SETTLEMENT_BATCH"] = "FINANCE_GIFT_CARD_CONSUME_ACCOUNT_SPLIT_SETTLEMENT_BATCH";
    /** 券消费分账结算单查询 */
    CustomColumnEnum["FINANCE_TICKET_CONSUME_ACCOUNT_SPLIT_SETTLEMENT"] = "FINANCE_TICKET_CONSUME_ACCOUNT_SPLIT_SETTLEMENT";
    /** 券消费分账结算单-批次查询 */
    CustomColumnEnum["FINANCE_TICKET_CONSUME_ACCOUNT_SPLIT_SETTLEMENT_BATCH"] = "FINANCE_TICKET_CONSUME_ACCOUNT_SPLIT_SETTLEMENT_BATCH";
    /** 总部账户分账结算单查询 */
    CustomColumnEnum["FINANCE_HEADQUARTERS_ACCOUNT_SPLIT_SETTLEMENT"] = "FINANCE_HEADQUARTERS_ACCOUNT_SPLIT_SETTLEMENT";
    /** 总部账户分账结算单-批次查询 */
    CustomColumnEnum["FINANCE_HEADQUARTERS_ACCOUNT_SPLIT_SETTLEMENT_BATCH"] = "FINANCE_HEADQUARTERS_ACCOUNT_SPLIT_SETTLEMENT_BATCH";
    /** 门店账户分账结算单查询 */
    CustomColumnEnum["FINANCE_LOCATION_ACCOUNT_SPLIT_SETTLEMENT"] = "FINANCE_LOCATION_ACCOUNT_SPLIT_SETTLEMENT";
    /** 门店账户分账结算单-批次查询 */
    CustomColumnEnum["FINANCE_LOCATION_ACCOUNT_SPLIT_SETTLEMENT_BATCH"] = "FINANCE_LOCATION_ACCOUNT_SPLIT_SETTLEMENT_BATCH";
    /** 自定义账户分账结算单查询 */
    CustomColumnEnum["FINANCE_CUSTOM_ACCOUNT_SPLIT_SETTLEMENT"] = "FINANCE_CUSTOM_ACCOUNT_SPLIT_SETTLEMENT";
    /** 自定义账户分账结算单-批次查询 */
    CustomColumnEnum["FINANCE_CUSTOM_ACCOUNT_SPLIT_SETTLEMENT_BATCH"] = "FINANCE_CUSTOM_ACCOUNT_SPLIT_SETTLEMENT_BATCH";
    /**
     * 商户支付-我的商户-子商户管理.
     */
    CustomColumnEnum["MERCHANT_PAY_MY_MERCHANT_SUB_MERCHANT_MGR"] = "MERCHANT_PAY_MY_MERCHANT_SUB_MERCHANT_MGR";
    /**
     * 商户支付-我的商户-子商户分组.
     */
    CustomColumnEnum["MERCHANT_PAY_MY_MERCHANT_SUB_MERCHANT_GROUP"] = "MERCHANT_PAY_MY_MERCHANT_SUB_MERCHANT_GROUP";
    /**
     * 加盟分账-资金流水-历史流水.
     */
    CustomColumnEnum["FINANCE_FINANCE_FLOW_HISTORY"] = "FINANCE_FINANCE_FLOW_HISTORY";
    /**
     * 加盟分账-资金流水-实时.
     */
    CustomColumnEnum["FINANCE_FINANCE_FLOW_HISTORY_REALTIME"] = "FINANCE_FINANCE_FLOW_HISTORY_REALTIME";
    /**
     * 加盟分账-付款记录-批次查询.
     */
    CustomColumnEnum["FINANCE_PAY_RECORD_BATCH"] = "FINANCE_PAY_RECORD_BATCH";
    /**
     * 加盟分账-付款记录-付款明细.
     */
    CustomColumnEnum["FINANCE_PAY_RECORD_DETAIL"] = "FINANCE_PAY_RECORD_DETAIL";
    /** 商户支付-门店子商户配置 */
    CustomColumnEnum["MERCHANT_PAY_LOCATION_SUB_MERCHANT_CONFIG"] = "MERCHANT_PAY_LOCATION_SUB_MERCHANT_CONFIG";
    /** 发票管理-开票记录 */
    CustomColumnEnum["INVOICE_MANAGEMENT_INVOICE_RECORD"] = "INVOICE_MANAGEMENT_INVOICE_RECORD";
    /** 加盟分账-款项设置 */
    CustomColumnEnum["FINANCE_ITEM_SETTING"] = "FINANCE_ITEM_SETTING";
    /** 加盟分账-财务主体变更记录 */
    CustomColumnEnum["FINANCE_SUBJECT_CHANGE_RECORD"] = "FINANCE_SUBJECT_CHANGE_RECORD";
    /** 加盟分账-流水明细 */
    CustomColumnEnum["FINANCE_FLOW_DETAIL"] = "FINANCE_FLOW_DETAIL";
    /** 加盟分账-记帐户流水 */
    CustomColumnEnum["FINANCE_RECORD_BALANCE_LOG"] = "FINANCE_RECORD_BALANCE_LOG";
    /** 加盟分账-分账稽核 */
    CustomColumnEnum["FINANCE_SPLIT_VERIFY"] = "FINANCE_SPLIT_VERIFY";
    /** 加盟分账-分账明细 */
    CustomColumnEnum["FINANCE_SPLIT_DETAIL"] = "FINANCE_SPLIT_DETAIL";
    /** 加盟分账-储值消费分账方案 */
    CustomColumnEnum["FINANCE_DEPOSIT_CONSUME_ACCOUNT_SPLIT_SCHEME"] = "FINANCE_DEPOSIT_CONSUME_ACCOUNT_SPLIT_SCHEME";
    /** 加盟分账-礼品卡消费分账方案 */
    CustomColumnEnum["FINANCE_GIFT_CARD_CONSUME_ACCOUNT_SPLIT_SCHEME"] = "FINANCE_GIFT_CARD_CONSUME_ACCOUNT_SPLIT_SCHEME";
    /** 加盟分账-券消费分账方案 */
    CustomColumnEnum["FINANCE_TICKET_CONSUME_ACCOUNT_SPLIT_SCHEME"] = "FINANCE_TICKET_CONSUME_ACCOUNT_SPLIT_SCHEME";
    /** 加盟分账-总部分账方案 */
    CustomColumnEnum["FINANCE_HEADQUARTERS_ACCOUNT_SPLIT_SCHEME"] = "FINANCE_HEADQUARTERS_ACCOUNT_SPLIT_SCHEME";
    /** 加盟分账-门店分账方案 */
    CustomColumnEnum["FINANCE_LOCATION_ACCOUNT_SPLIT_SCHEME"] = "FINANCE_LOCATION_ACCOUNT_SPLIT_SCHEME";
    /** 加盟分账-总部费用单 */
    CustomColumnEnum["FINANCE_HEADQUARTERS_COST_ORDER"] = "FINANCE_HEADQUARTERS_COST_ORDER";
    /** 加盟分账-门店费用单 */
    CustomColumnEnum["FINANCE_LOCATION_COST_ORDER"] = "FINANCE_LOCATION_COST_ORDER";
    /** 加盟分账-自定义分账方案 */
    CustomColumnEnum["FINANCE_CUSTOM_ACCOUNT_SPLIT_SCHEME"] = "FINANCE_CUSTOM_ACCOUNT_SPLIT_SCHEME";
    /** POS门店商品 */
    CustomColumnEnum["POS_LOCATION_PRODUCT"] = "POS_LOCATION_PRODUCT";
    /** 商品类别 */
    CustomColumnEnum["PRODUCT_CATEGORY"] = "PRODUCT_CATEGORY";
    /** 门店商品类别 */
    CustomColumnEnum["LOCATION_PRODUCT_CATEGORY"] = "LOCATION_PRODUCT_CATEGORY";
    /** 商品系列 */
    CustomColumnEnum["PRODUCT_COLLECTION"] = "PRODUCT_COLLECTION";
    // /** [前端] - 商品管理模块，业务列表-表格按标准组件-2 需要的枚举，别删除，后面放开 */
    /** 收入科目 */
    CustomColumnEnum["INCOME_SUBJECT"] = "INCOME_SUBJECT";
    /** 做法管理 */
    CustomColumnEnum["PROPERTY_METHOD"] = "PROPERTY_METHOD";
    /** 加料管理 */
    CustomColumnEnum["PROPERTY_FEED"] = "PROPERTY_FEED";
    /** 门店做法管理 */
    CustomColumnEnum["LOCATION_PROPERTY_METHOD"] = "LOCATION_PROPERTY_METHOD";
    /** 门店加料管理 */
    CustomColumnEnum["LOCATION_PROPERTY_FEED"] = "LOCATION_PROPERTY_FEED";
    /** 规格管理 */
    CustomColumnEnum["PRODUCT_VARAINT"] = "PRODUCT_VARAINT";
    /** 门店规格管理 */
    CustomColumnEnum["LOCATION_PRODUCT_VARAINT"] = "LOCATION_PRODUCT_VARAINT";
    /** 包装盒管理 */
    CustomColumnEnum["PACKAGE_BOX"] = "PACKAGE_BOX";
    /** 商品时段 */
    CustomColumnEnum["PRODUCT_TIME_PERIOD"] = "PRODUCT_TIME_PERIOD";
    /** 时段菜单 */
    CustomColumnEnum["TIME_PERIOD_MENU"] = "TIME_PERIOD_MENU";
    /** 门店时段菜单 */
    CustomColumnEnum["TIME_PERIOD_MENU_STORE"] = "TIME_PERIOD_MENU_STORE";
    /** 调价单 */
    CustomColumnEnum["ADJUST_PRICE_ORDER"] = "ADJUST_PRICE_ORDER";
    /** 商品打印配置-总部商品配置 */
    CustomColumnEnum["HEADQUARTERS_PRODUCT_CONFIG"] = "HEADQUARTERS_PRODUCT_CONFIG";
    /** 商品打印配置-门店商品配置 */
    CustomColumnEnum["LOCATION_PRODUCT_CONFIG"] = "LOCATION_PRODUCT_CONFIG";
    /** 商品模版 */
    CustomColumnEnum["PRODUCT_TMPL"] = "PRODUCT_TMPL";
    /** 定时变价 */
    CustomColumnEnum["NEW_ADJUST_PRICE_ORDER"] = "NEW_ADJUST_PRICE_ORDER";
    /** 商品同步-同步记录 */
    CustomColumnEnum["PRODUCT_SYNC_RECORD"] = "PRODUCT_SYNC_LOG";
    /** 库存变动-库存 */
    CustomColumnEnum["INVENTORY_CHANGE_STATISTICS"] = "PRODUCT_INVENTORY_CHANGE";
    /** 库存变动-虚拟库存 */
    CustomColumnEnum["INVENTORY_CHANGE_VIRTUAL_INVENTORY"] = "PRODUCT_VIRTUAL_INVENTORY_CHANGE";
    /** 库存同步-按商品设置 */
    CustomColumnEnum["INVENTORY_SYNC_BY_PRODUCT"] = "INVENTORY_SYNC_PRODUCT";
    /** 库存同步-按门店设置 */
    CustomColumnEnum["INVENTORY_SYNC_BY_LOCATION"] = "INVENTORY_SYNC_LOCATION";
    /** 计划库存 */
    CustomColumnEnum["PLAN_INVENTORY"] = "PLAN_INVENTORY";
    // 订单模块
    /** 寄存单 - 寄存单明细 */
    CustomColumnEnum["STORAGE_ORDER"] = "STORAGE_ORDER";
    /** 寄存单 - 寄存单存取明细 */
    CustomColumnEnum["STORAGE_OPERATE_ORDER"] = "STORAGE_OPERATE_ORDER";
    /** 个人挂帐 - 总部个人挂帐 */
    CustomColumnEnum["PERSON_PENDING_ACCOUNT"] = "PERSON_PENDING_ACCOUNT";
    /** 个人挂帐 - 门店个人挂帐 */
    CustomColumnEnum["LOCATION_PERSON_PENDING_ACCOUNT"] = "LOCATION_PERSON_PENDING_ACCOUNT";
    /** 企业挂帐 - 总部企业挂帐 */
    CustomColumnEnum["ENTERPRISE_PENDING_ACCOUNT"] = "ENTERPRISE_PENDING_ACCOUNT";
    /** 企业挂帐 - 门店企业挂帐 */
    CustomColumnEnum["LOCATION_ENTERPRISE_PENDING_ACCOUNT"] = "LOCATION_ENTERPRISE_PENDING_ACCOUNT";
    /** 财务主体 */
    CustomColumnEnum["FINANCE_SUBJECT"] = "FINANCE_SUBJECT";
    /** 会员复购汇总 */
    CustomColumnEnum["CUSTOMER_REPURCHASE"] = "CUSTOMER_REPURCHASE";
    /** 会员商品复购 */
    CustomColumnEnum["CUSTOMER_REPURCHASE_PRODUCT_DETAIL"] = "CUSTOMER_REPURCHASE_PRODUCT_DETAIL";
    /** 会员复购汇总明细 */
    CustomColumnEnum["CUSTOMER_REPURCHASE_DETAIL"] = "CUSTOMER_REPURCHASE_DETAIL";
    /** 会员消费占比 */
    CustomColumnEnum["CUSTOMER_CONSUME_RATIO_STATISTICS"] = "CUSTOMER_CONSUME_RATIO_STATISTICS";
    /** 商品营销统计 */
    CustomColumnEnum["PRODUCT_MARKETING_STATISTICS"] = "PRODUCT_MARKETING_STATISTICS";
    /** 会员概览 */
    CustomColumnEnum["CUSTOMER_MEMBER_OVERVIEW"] = "CUSTOMER_MEMBER_OVERVIEW";
    /** 券模板分析 */
    CustomColumnEnum["DISCOUNT_TICKET_TMPL_ANALYSIS"] = "DISCOUNT_TICKET_TMPL_ANALYSIS";
    /** 券包销售统计 */
    CustomColumnEnum["TICKET_PACKAGE_SALE_STATISTICS"] = "TICKET_PACKAGE_SALE_STATISTICS";
    /** 卡模板分析 */
    CustomColumnEnum["GIFT_CARD_TMPL_ANALYSIS"] = "GIFT_CARD_TMPL_ANALYSIS";
    /** 礼品卡明细 */
    CustomColumnEnum["GIFT_CARD_DETAIL"] = "GIFT_CARD_DETAIL";
    /** 积分分析 */
    CustomColumnEnum["POINT_ANALYSIS"] = "POINT_ANALYSIS";
    /** 用户业绩 */
    CustomColumnEnum["USER_PERFORMANCE"] = "USER_PERFORMANCE";
    /** 营业收款稽核 */
    CustomColumnEnum["BUSINESS_PAY_VERIFY"] = "BUSINESS_PAY_VERIFY";
    /** 页面分析 */
    CustomColumnEnum["MINI_PROGRAM_PAGE_ANALYSIS"] = "MINI_PROGRAM_PAGE_ANALYSIS";
    /** 留存分析日维度 */
    CustomColumnEnum["MINI_PROGRAM_DAY_RETENTION_ANALYSIS"] = "MINI_PROGRAM_DAY_RETENTION_ANALYSIS";
    /** 留存分析周维度 */
    CustomColumnEnum["MINI_PROGRAM_WEEK_RETENTION_ANALYSIS"] = "MINI_PROGRAM_WEEK_RETENTION_ANALYSIS";
    /** 收入优惠报表 */
    CustomColumnEnum["INCOME_DISCOUNT_STATISTICS"] = "INCOME_DISCOUNT_STATISTICS";
    /** 库存周转率 */
    CustomColumnEnum["INVENTORY_TURNOVER_BY_QTY"] = "INVENTORY_TURNOVER_BY_QTY";
    /** 库存周转率-金额 */
    CustomColumnEnum["INVENTORY_TURNOVER_BY_MONEY"] = "INVENTORY_TURNOVER_BY_MONEY";
    /** 销售客户 */
    CustomColumnEnum["WHOLESALE_CUSTOMER"] = "WHOLESALE_CUSTOMER";
    /** 开票申请 */
    CustomColumnEnum["INVOICE_MANAGEMENT_INVOICE_APPLY"] = "INVOICE_MANAGEMENT_INVOICE_APPLY";
    /** 短信群发 */
    CustomColumnEnum["SMS_GROUP_SEND"] = "SMS_GROUP_SEND";
    /** 短信模板 */
    CustomColumnEnum["SMS_TMPL"] = "SMS_TMPL";
    /** 短信模板类型 */
    CustomColumnEnum["SMS_TMPL_TYPE"] = "SMS_TMPL_TYPE";
    /** 客户物品销售查询-按客户汇总 */
    CustomColumnEnum["WHOLESALE_REPORT_BY_CUSTOMER"] = "WHOLESALE_REPORT_BY_CUSTOMER";
    /** 客户物品销售查询-按物品汇总 */
    CustomColumnEnum["WHOLESALE_REPORT_BY_ITEM"] = "WHOLESALE_REPORT_BY_ITEM";
    /** 客户物品销售查询-客户物品销售 */
    CustomColumnEnum["WHOLESALE_REPORT_BY_CUSTOMER_ITEM"] = "WHOLESALE_REPORT_BY_CUSTOMER_ITEM";
    /** 客户物品销售查询-按物品明细 */
    CustomColumnEnum["WHOLESALE_REPORT_BY_ITEM_DETAIL"] = "WHOLESALE_REPORT_BY_ITEM_DETAIL";
    /** 客户物品销售查询-按类别汇总 */
    CustomColumnEnum["WHOLESALE_REPORT_BY_ITEM_TYPE"] = "WHOLESALE_REPORT_BY_ITEM_TYPE";
    /** 客户物品销售查询-按门店汇总 */
    CustomColumnEnum["WHOLESALE_REPORT_BY_LOCATION"] = "WHOLESALE_REPORT_BY_LOCATION";
    /** 门店财务主体配置 */
    CustomColumnEnum["LOCATION_FINANCE_SUBJECT_CONFIG"] = "LOCATION_FINANCE_SUBJECT_CONFIG";
    /** 优惠券 */
    CustomColumnEnum["DISCOUNT_TICKET"] = "DISCOUNT_TICKET";
    /** 优惠券 */
    CustomColumnEnum["DISCOUNT_TICKET_BATCH_CREATE"] = "DISCOUNT_TICKET_BATCH_CREATE";
    /** 优惠券-券明细 */
    CustomColumnEnum["DISCOUNT_TICKET_DETAIL"] = "DISCOUNT_TICKET_DETAIL";
    /** 礼品卡 */
    CustomColumnEnum["GIFT_CARD"] = "GIFT_CARD";
    /** 礼品卡主题 */
    CustomColumnEnum["GIFT_CARD_THEME"] = "GIFT_CARD_THEME";
    /** 礼品卡批量制卡 */
    CustomColumnEnum["GIFT_CARD_BATCH_CREATE"] = "GIFT_CARD_BATCH_CREATE";
    /** 权益卡模板 */
    CustomColumnEnum["RIGHT_CARD_TMPL"] = "RIGHT_CARD_TMPL";
    /** 权益卡明细 */
    CustomColumnEnum["RIGHT_CARD_DETAIL"] = "RIGHT_CARD_DETAIL";
    /** 注册有礼 */
    CustomColumnEnum["GIFT_GET_CARD"] = "GIFT_GET_CARD";
    /** 好友裂变 */
    CustomColumnEnum["CUSTOMER_FISSION"] = "CUSTOMER_FISSION";
    /** 新客专享 */
    CustomColumnEnum["NEW_CUSTOMER_EXCLUSIVE"] = "NEW_CUSTOMER_EXCLUSIVE";
    /** 领券活动 */
    CustomColumnEnum["GET_TICKET_ACTIVITY"] = "GET_TICKET_ACTIVITY";
    /** 弹窗发券 */
    CustomColumnEnum["POPUP_TICKET"] = "POPUP_TICKET";
    /** 优惠券包 */
    CustomColumnEnum["DISCOUNT_TICKET_PACK"] = "DISCOUNT_TICKET_PACK";
    /** 拼团 */
    CustomColumnEnum["GROUP_BUYING"] = "GROUP_BUYING";
    /** 消费有礼 */
    CustomColumnEnum["GIFT_CONSUME"] = "GIFT_CONSUME";
    /** 推荐商品 */
    CustomColumnEnum["RECOMMEND_PRODUCT_ACTIVITY"] = "RECOMMEND_PRODUCT_ACTIVITY";
    /** 推荐加购 */
    CustomColumnEnum["RECOMMEND_PURCHASE"] = "RECOMMEND_PURCHASE";
    /** 签到有礼-签到记录 */
    CustomColumnEnum["GIFT_SIGN_IN_RECORD"] = "GIFT_SIGN_IN_RECORD";
    /** 集点卡 */
    CustomColumnEnum["COLLECT_STAMP"] = "COLLECT_STAMP";
    /** 群接龙 */
    CustomColumnEnum["GROUP_RELAY"] = "GROUP_RELAY";
    /** 评价有礼 */
    CustomColumnEnum["GIFT_REVIEW"] = "GIFT_REVIEW";
    /** 储值活动 */
    CustomColumnEnum["GIFT_DEPOSIT"] = "GIFT_DEPOSIT";
    /** 升级有礼 */
    CustomColumnEnum["GIFT_LEVEL_UP"] = "GIFT_LEVEL_UP";
    /** 积分商城-积分兑换活动 */
    CustomColumnEnum["POINT_EXCHANGE"] = "POINT_EXCHANGE";
    /** 积分商城-积分兑换记录 */
    CustomColumnEnum["POINT_EXCHANGE_RECORD"] = "POINT_EXCHANGE_RECORD";
    /** 生日有礼 */
    CustomColumnEnum["GIFT_BIRTHDAY"] = "GIFT_BIRTHDAY";
    /** 问卷调查 */
    CustomColumnEnum["QUESTIONNAIRE_SURVEY"] = "QUESTIONNAIRE_SURVEY";
    /** 广告管理 */
    CustomColumnEnum["AD_MGR"] = "AD_MGR";
    /** 精准营销 */
    CustomColumnEnum["TIMED_GIFT_TICKET"] = "TIMED_GIFT_TICKET";
    /** 抽奖有礼 */
    CustomColumnEnum["GIFT_LUCKY_DRAW"] = "GIFT_LUCKY_DRAW";
    /** 任务活动 */
    CustomColumnEnum["TASK_ACTIVITY"] = "TASK_ACTIVITY";
    /** 趣味竞猜-竞猜列表 */
    CustomColumnEnum["FUN_GUESS"] = "FUN_GUESS";
    /** 趣味竞猜-比赛列表 */
    CustomColumnEnum["FUN_MATCH"] = "FUN_MATCH";
    /** 替代品管理 */
    CustomColumnEnum["COST_CARD_REPLACE_PLAN"] = "COST_CARD_REPLACE_PLAN";
    /** 配送毛利-门店调出明细 */
    CustomColumnEnum["SHIP_GROSS_PROFIT_BY_LOCATION_TRANSFER_OUT_DETAIL"] = "SHIP_GROSS_PROFIT_BY_LOCATION_TRANSFER_OUT_DETAIL";
})(CustomColumnEnum || (exports.CustomColumnEnum = CustomColumnEnum = {}));
// 筛选器自定义枚举
var CustomFilterEnum;
(function (CustomFilterEnum) {
    /** 库存调整单-物品查询筛选器 */
    CustomFilterEnum["ADJUSTMENT_ORDER_PRODUCT"] = "ADJUSTMENT_ORDER_PRODUCT";
    /** 盘点单-物品查询筛选器 */
    CustomFilterEnum["CHECK_ORDER_PRODUCT"] = "CHECK_ORDER_PRODUCT";
    /** 配方管理-物品查询筛选器 */
    CustomFilterEnum["FINISHED_PRODUCT"] = "FINISHED_PRODUCT";
    /** 内部申请单-物品查询筛选器 */
    CustomFilterEnum["INNER_ORDER_ORDER_PRODUCT"] = "INNER_ORDER_ORDER_PRODUCT";
    /** 内部申请单筛选器 */
    CustomFilterEnum["INNER_APPLY_ORDER"] = "INNER_APPLY_ORDER";
    /** 快速生产单-物品查询筛选器 */
    CustomFilterEnum["PRODUCE_FAST_ORDER_PRODUCT"] = "PRODUCE_FAST_ORDER_PRODUCT";
    /** 生产领料单-物品查询筛选器 */
    CustomFilterEnum["PRODUCE_MATERIAL_ORDER_PRODUCT"] = "PRODUCE_MATERIAL_ORDER_PRODUCT";
    /** 生产计划单-物品查询筛选器 */
    CustomFilterEnum["PRODUCE_PLAN_ORDER_PRODUCT"] = "PRODUCE_PLAN_ORDER_PRODUCT";
    /** 生产入库单-物品查询筛选器 */
    CustomFilterEnum["PRODUCE_STORAGE_ORDER_PRODUCT"] = "PRODUCE_STORAGE_ORDER_PRODUCT";
    /** 采购单-物品查询筛选器 */
    CustomFilterEnum["PURCHASE_ORDER_PRODUCT"] = "PURCHASE_ORDER_PRODUCT";
    /** 收货单-物品查询筛选器 */
    CustomFilterEnum["RECEIVE_ORDER_PRODUCT"] = "RECEIVE_ORDER_PRODUCT";
    /** 要货单-物品查询筛选器 */
    CustomFilterEnum["REQUEST_ORDER_PRODUCT"] = "REQUEST_ORDER_PRODUCT";
    /** 要货单筛选器 */
    CustomFilterEnum["REQUEST_ORDER"] = "REQUEST_ORDER";
    /** 退货单-物品查询筛选器 */
    CustomFilterEnum["RETURN_ORDER_PRODUCT"] = "RETURN_ORDER_PRODUCT";
    /** 调入单-物品查询筛选器 */
    CustomFilterEnum["TRANSFER_IN_ORDER_PRODUCT"] = "TRANSFER_IN_ORDER_PRODUCT";
    /** 调出单-物品查询筛选器 */
    CustomFilterEnum["TRANSFER_OUT_ORDER_PRODUCT"] = "TRANSFER_OUT_ORDER_PRODUCT";
    /** 调出单筛选器 */
    CustomFilterEnum["TRANSFER_OUT_ORDER"] = "TRANSFER_OUT_ORDER";
    /** 门店配送价-物品查询筛选器 */
    CustomFilterEnum["LOCATION_DISTRIBUTION_PRICE_PRODUCT"] = "LOCATION_DISTRIBUTION_PRICE_PRODUCT";
    /** 配送毛利-物品查询筛选器 */
    CustomFilterEnum["DISTRIBUTION_GROSS_PRODUCT"] = "DISTRIBUTION_GROSS_PRODUCT";
    /** 物品进出明细-物品查询筛选器 */
    CustomFilterEnum["INVENTOTY_CHANGE_STATISTICS_PRODUCT"] = "INVENTOTY_CHANGE_STATISTICS_PRODUCT";
    /** 要货模版-物品查询筛选器 */
    CustomFilterEnum["REQUEST_ORDER_TEMPLATE_PRODUCT"] = "REQUEST_ORDER_TEMPLATE_PRODUCT";
    /** 配送中心筛选器 */
    CustomFilterEnum["DISTRIBUTION_CENTER"] = "DISTRIBUTION_CENTER";
    /** 门店费用筛选器 */
    CustomFilterEnum["LOCATION_FEE_ORDER"] = "LOCATION_FEE_ORDER";
    /** 门店预收*/
    CustomFilterEnum["LOCATION_PRE_RECEIPT_ORDER"] = "LOCATION_PRE_RECEIPT_ORDER";
    /** 门店结算 */
    CustomFilterEnum["LOCATION_SETTLEMENT_ORDER"] = "LOCATION_SETTLEMENT_ORDER";
    /** 物品在途 */
    CustomFilterEnum["PRODUCT_IN_TRANSIT"] = "PRODUCT_IN_TRANSIT";
    /** 供应商预付 */
    CustomFilterEnum["SUPPLIER_PRE_PAY_ORDER"] = "SUPPLIER_PRE_PAY_ORDER";
    /** 供应商结算 */
    CustomFilterEnum["SUPPLIER_SETTLEMENT_ORDER"] = "SUPPLIER_SETTLEMENT_ORDER";
    /** 调入单 */
    CustomFilterEnum["TRANSFER_IN_ORDER"] = "TRANSFER_IN_ORDER";
    /** 库存成本调整单 */
    CustomFilterEnum["ADJUSTMENT_COST_ORDER"] = "ADJUSTMENT_COST_ORDER";
    /** 库存调整 */
    CustomFilterEnum["ADJUSTMENT_ORDER"] = "ADJUSTMENT_ORDER";
    /** 库存转仓 */
    CustomFilterEnum["ALLOCATION_ORDER"] = "ALLOCATION_ORDER";
    /** 盘点单 */
    CustomFilterEnum["CHECK_ORDER"] = "CHECK_ORDER";
    /** 配送毛利分析 */
    CustomFilterEnum["DISTRIBUTION_GROSS_PROFIT"] = "DISTRIBUTION_GROSS_PROFIT";
    /** 生产看板 */
    CustomFilterEnum["PRODUCE_BOARD"] = "PRODUCE_BOARD";
    /** 应产率报表 */
    CustomFilterEnum["PRODUCE_ITEM_EXPECTED_RATE"] = "PRODUCE_ITEM_EXPECTED_RATE";
    /** 生产汇总表 */
    CustomFilterEnum["PRODUCE_ITEM_SUMMARY_REPORT"] = "PRODUCE_ITEM_SUMMARY_REPORT";
    /** 门店加工单 */
    CustomFilterEnum["PRODUCE_LOCATION_STORAGE_ORDER"] = "PRODUCE_LOCATION_STORAGE_ORDER";
    /** 加工品原料耗用分析表 */
    CustomFilterEnum["PRODUCE_MATERIAL_CONSUMPTION"] = "PRODUCE_MATERIAL_CONSUMPTION";
    /** 生产领料单 */
    CustomFilterEnum["PRODUCE_MATERIAL_ORDER"] = "PRODUCE_MATERIAL_ORDER";
    /** 生产计划单 */
    CustomFilterEnum["PRODUCE_PLAN_ORDER"] = "PRODUCE_PLAN_ORDER";
    /** 生产入库单 */
    CustomFilterEnum["PRODUCE_STORAGE_ORDER"] = "PRODUCE_STORAGE_ORDER";
    /** 采购订单监控 */
    CustomFilterEnum["PURCHASE_MONITOR"] = "PURCHASE_MONITOR";
    /** 采购单 */
    CustomFilterEnum["PURCHASE_ORDER"] = "PURCHASE_ORDER";
    /** 直发单 */
    CustomFilterEnum["PURCHASE_ORDER_SHIPMENT"] = "PURCHASE_ORDER_SHIPMENT";
    /** 采购汇总明细 */
    CustomFilterEnum["PURCHASE_SUMMARY_DETAIL"] = "PURCHASE_SUMMARY_DETAIL";
    /** 收货单 */
    CustomFilterEnum["RECEIVE_ORDER"] = "RECEIVE_ORDER";
    /** 退货单 */
    CustomFilterEnum["RETURN_ORDER"] = "RETURN_ORDER";
    /** 供应商费用 */
    CustomFilterEnum["SUPPLIER_FEE_ORDER"] = "SUPPLIER_FEE_ORDER";
    /** 进销存变动统计 */
    CustomFilterEnum["PSI_INVENTORY_CHANGE"] = "PSI_INVENTORY_CHANGE";
    /** 物品库存查询 */
    CustomFilterEnum["STOCK_INVENTORY_LEVEL"] = "STOCK_INVENTORY_LEVEL";
    /** 库存进出明细 */
    CustomFilterEnum["STOCK_INVENTORY_LEVEL_LOG"] = "STOCK_INVENTORY_LEVEL_LOG";
    /** 入库汇总 */
    CustomFilterEnum["STOCK_INVENTORY_LEVEL_LOG_IN_SUM"] = "STOCK_INVENTORY_LEVEL_LOG_IN_SUM";
    /** 出库汇总 */
    CustomFilterEnum["STOCK_INVENTORY_LEVEL_LOG_OUT_SUM"] = "STOCK_INVENTORY_LEVEL_LOG_OUT_SUM";
    /** 库存进出汇总 */
    CustomFilterEnum["STOCK_INVENTORY_LEVEL_LOG_SUM"] = "STOCK_INVENTORY_LEVEL_LOG_SUM";
    /** 生产模块报表-加工品查询筛选器 */
    CustomFilterEnum["PRODUCE_REPORT_PRODUCE_ITEM"] = "PRODUCE_REPORT_PRODUCE_ITEM";
    /** 会员报表-储值支付方式明细筛选器 */
    CustomFilterEnum["DEPOSIT_PAYMENT_TYPE_DETAIL"] = "DEPOSIT_PAYMENT_TYPE_DETAIL";
    /** 餐区/台位营业统计筛选器 */
    CustomFilterEnum["BUSINESS_ZONE_TABLE_STATISTICS"] = "BUSINESS_ZONE_TABLE_STATISTICS";
    /** 断货分析 */
    CustomFilterEnum["STOCK_INTERRUPT"] = "STOCK_INTERRUPT";
    /** 商品销售汇总 */
    CustomFilterEnum["PRODUCT_SALE_SUMMARY"] = "PRODUCT_SALE_SUMMARY";
    /** 超量折扣 */
    CustomFilterEnum["EXCEED_DISCOUNT_ORDER"] = "EXCEED_DISCOUNT_ORDER";
    /** 客户物品销售查询筛选器 */
    CustomFilterEnum["WHOLESALE_ITEMS_SALES_QUERY"] = "WHOLESALE_ITEMS_SALES_QUERY";
    /** 销售报价单筛选器 */
    CustomFilterEnum["WHOLESALE_QUOTE_ORDER"] = "WHOLESALE_QUOTE_ORDER";
})(CustomFilterEnum || (exports.CustomFilterEnum = CustomFilterEnum = {}));
